import type { ILang } from '@core/interfaces/ILang';

const lang: ILang = {
  alert: {
    abort: 'Batalkan',
    buy: 'Beli',
    cancel: 'Batal',
    caption: 'Kesalahan',
    close: 'Tutup',
    confirm: 'Konfirmasi',
    dont_save: 'Jangan Simpan',
    dont_show_again: 'Jangan tampilkan lagi',
    duplicated_preset_name: 'Nama preset duplikat',
    error: 'KESALAHAN',
    info: 'INFO',
    instruction: 'Petunjuk',
    learn_more: 'Pelajari Lebih Lanjut',
    no: 'Tidak',
    ok: 'OK',
    ok2: 'OK',
    oops: 'Ups...',
    retry: 'Coba lagi',
    save: 'Simpan',
    stop: 'Berhenti',
    warning: 'PERINGATAN',
    yes: 'Ya',
  },
  auto_fit: {
    artwork_size: 'Ukuran Karya Seni',
    error_tip1: '1. Apakah karya seni ditempatkan dengan benar pada bahan?',
    error_tip2: '2. Apakah kontur material cukup jelas untuk dikenali?',
    failed_to_find_contour: 'Gagal menemukan kontur untuk penyesuaian otomatis',
    how_to_improve_accuracy: 'Bagaimana cara meningkatkan akurasi deteksi?',
    how_to_improve_accuracy_url: 'https://support.flux3dp.com/hc/en-us/articles/15792349372687',
    learn_more: 'Lihat tutorial',
    learn_more_url: 'https://support.flux3dp.com/hc/en-us/articles/10273384373775',
    offset_x: 'Pergeseran X',
    offset_y: 'Pergeseran Y',
    pattern_size: 'Ukuran Pola',
    position_artwork: 'Posisikan Karya Seni',
    position_step1: 'Sesuaikan ukuran dan posisi karya seni Anda pada pola.',
    position_step2: 'Klik "Terapkan" untuk menerapkan Auto Fit pada pola ini.',
    preview_first: 'Silakan lakukan pratinjau kamera terlebih dahulu.',
    reset_position: 'Atur Ulang Posisi',
    retake: 'Ambil Ulang Foto',
    retake_tooltip: 'Ambil ulang foto kamera di posisi setiap objek untuk deteksi yang lebih baik',
    retry_with_remove_bg: 'Hapus Latar Belakang',
    retry_with_remove_bg_tooltip: 'Hapus latar belakang dari gambar pratinjau untuk meningkatkan deteksi kontur',
    rotation: 'Putar',
    select_a_pattern: 'Pilih Pola',
    selected_artwork: 'Karya Seni yang Dipilih',
    step1: 'Pilih pola tempat Anda ingin meletakkan karya seni.',
    step2: 'Jika tidak ditemukan pola, pratinjau kamera lagi dan terapkan Pas Otomatis.',
    step3: 'Jika masih gagal menemukan pola yang benar, pastikan benda kerja Anda dapat dikenali dengan jelas dan area kerja bersih dari kotoran.',
    title: 'Pas Otomatis',
    use_original_image: 'Gunakan gambar asli',
    use_original_image_tooltip: 'Kembalikan gambar pratinjau asli tanpa penghapusan latar belakang',
    warning_bg_removal: 'Operasi ini akan menjalankan fitur "Hapus Latar Belakang", yang akan menggunakan 0,02 Credit. Apakah Anda ingin melanjutkan?',
    warning_retake_preview: 'Operasi ini adalah pengambilan ulang sebagian. Gambar dan latar belakang baru akan ditambahkan. Apakah Anda ingin melanjutkan?',
  },
  autosave: {
    open_settings: 'Buka Pengaturan',
    path_not_correct: 'Lokasi Simpan Otomatis tidak ada lagi.',
    path_not_correct_desc: 'Silakan pilih folder baru di <b>%(preferences)s > %(autosave)s > %(path)s</b> untuk melanjutkan menyimpan pekerjaan Anda.',
  },
  barcode_generator: {
    bar_height: 'Tinggi Batang',
    bar_width: 'Lebar Batang',
    barcode: {
      invalid_value: 'Nilai tidak valid untuk format yang dipilih.',
    },
    font: 'Font',
    font_size: 'Ukuran Font',
    hide_text: 'Sembunyikan Teks',
    invert_color: 'Balik Warna',
    text: 'Teks',
    text_margin: 'Margin Teks',
  },
  beambox: {
    ai_generate: {
      dimensions: {
        more: 'Lainnya',
        ratio: 'Rasio',
        resolution: 'Resolusi',
        title: 'Dimensi Gambar',
      },
      error: {
        config_description: 'Gagal memuat konfigurasi AI',
        config_message: 'Gagal memuat gaya AI',
        generation_failed: 'Pembuatan gagal',
        import_failed: 'Impor gagal',
        insufficient_credits: 'Kredit tidak mencukupi',
      },
      form: {
        count: 'Jumlah',
        credit_required: 'Kredit yang diperlukan',
        editor: 'Penyunting',
        generate: 'Buat',
        laser_friendly: 'Ramah Laser',
      },
      header: {
        history_tooltip: 'Riwayat',
        reset_tooltip: 'Reset Semua',
        title: 'Pembuatan AI',
      },
      history: {
        detail: 'Rincian',
        empty_description: 'Belum ada riwayat pembuatan. Mulai membuat!',
        error_message: 'Gagal memuat riwayat',
        not_generated: '❌ Tidak dibuat',
        recreate: 'Buat Ulang',
        status_failed: 'Gagal',
        status_generating: 'Membuat',
        status_success: 'Berhasil',
        storage_notice: 'Hingga 10 catatan terbaru disimpan. Gambar yang dihasilkan disimpan selama 3 hari.',
        title: 'Riwayat Pembuatan',
      },
      loading: {
        history: 'Memuat riwayat...',
        styles: 'Memuat gaya AI...',
        tip_0: 'Menjalankan mesin kreatif…',
        tip_1: 'Menghaluskan piksel… ✨',
        tip_2: 'Hampir selesai, menyempurnakan detail',
        tip_3: 'Masih membuat, bagian ini butuh waktu lebih',
        tip_4: 'Ide besar butuh waktu, terima kasih atas kesabaran Anda',
      },
      results: {
        download: 'Unduh',
        import: 'Impor',
        title: 'Hasil',
      },
      retry: 'Coba Lagi',
      style: {
        apply: 'Terapkan Gaya',
        choose: 'Pilih Gaya',
        custom_creation: 'Pembuatan Kustom',
        customize: 'Kustomisasi',
        select: 'Pilih Gaya Pembuatan',
      },
      upload: {
        add: 'Tambah',
        click_or_drag: 'Klik atau seret gambar ke sini',
        error: 'Kesalahan Unggah',
        file_size_error: '%s: Ukuran file harus kurang dari %sMB',
        file_type_error: '%s: Hanya gambar JPEG, PNG, dan WebP yang didukung',
        from_history: 'Dari riwayat',
        images: 'Unggah gambar',
        max_images_error: 'Maksimal %s gambar diizinkan',
        selected: '%s / %s dipilih',
        supported_formats: 'JPEG, PNG, WebP • Maks %s',
      },
      validation: {
        description_or_image_required: 'Berikan deskripsi atau unggah setidaknya satu gambar',
        field_exceeds_max_length: '"%s" melebihi panjang maksimal %s karakter.',
        field_required: '"%s" wajib diisi. Silakan isi bidang ini.',
        login_required: 'Silakan masuk untuk menggunakan pembuatan AI.',
        max_images: 'Maksimal %s gambar diizinkan',
      },
    },
    announcement_panel: {
      title: 'Pengumuman',
    },
    banner: {
      auto_feeder: 'Mode Pengumpan Otomatis',
      autofocus1: 'Mode Autofokus',
      autofocus2: 'Klik di mana saja untuk melakukan autofokus.',
      camera_preview_borderless_mode: '(Bawah Terbuka)',
      curve_engraving: 'Mode Ukiran Lengkung',
      pass_through: 'Mode Lintasan',
      rotary: 'Mode Putar',
    },
    bottom_right_panel: {
      convert_text_to_path_before_export: 'Ubah Teks Menjadi Lintasan...',
      export_file_error_ask_for_upload: 'Gagal mengekspor pekerjaan. Apakah Anda bersedia memberikan adegan kerja kepada tim pengembang untuk laporan bug?',
      retreive_image_data: 'Ambil Data Gambar...',
    },
    context_menu: {
      copy: 'Salin',
      cut: 'Potong',
      delete: 'Hapus',
      duplicate: 'Duplikat',
      group: 'Grup',
      move_back: 'Kirim ke Belakang',
      move_down: 'Kirim ke Bawah',
      move_front: 'Bawa ke Depan',
      move_up: 'Bawa ke Atas',
      paste: 'Tempel',
      paste_in_place: 'Tempel di Tempat',
      ungroup: 'Batalkan Grup',
    },
    document_panel: {
      add_on: 'Add-on',
      auto_feeder: 'Pengumpan otomatis',
      auto_feeder_url: 'https://support.flux3dp.com/hc/en-us/articles/11688230498575',
      auto_shrink: 'Pengecilan Otomatis',
      auto_shrink_tooltip: 'Hanya berlaku untuk lapisan dengan resolusi lebih besar atau sama dengan 250 DPI.',
      auto_shrink_url: 'https://support.flux3dp.com/hc/en-us/articles/12997377035919',
      borderless_mode: 'Buka Bawah',
      current_position: 'Posisi Saat Ini',
      disable: 'Nonaktifkan',
      document_settings: 'Pengaturan Dokumen',
      door_protect: 'Perlindungan pintu',
      door_protect_desc: 'Tersedia hanya dengan Promark Safe+.',
      enable_autofocus: 'Autofokus',
      enable_diode: 'Laser Diode',
      enable_nozzle_refresh_area: 'Aktifkan area penyegaran nozel',
      extend_y_area: 'Perpanjang area Y',
      frame_before_start: 'Frame sebelum menjalankan',
      frame_before_start_url: 'https://support.flux3dp.com/hc/en-us/articles/11494925637135',
      job_origin: 'Asal Tugas',
      laser_source: 'Sumber Laser',
      machine: 'Mesin',
      manual: 'Manual',
      notification: {
        changeFromPrintingWorkareaTitle: 'Apakah Anda ingin mengubah Lapisan Cetak menjadi Lapisan Laser?',
      },
      origin: 'Asal',
      pass_through: 'Lewat langsung',
      pass_through_height_desc: 'Masukkan panjang objek untuk memperluas area kerja.',
      prespray_times: 'Jumlah pembersihan',
      rotary_mode: 'Putar',
      scale: 'Skala',
      skip_prespray: 'Lewati pembersihan awal',
      start_from: 'Mulai Dari',
      start_position: 'Posisi Awal',
      start_work_button: 'Tombol Eksekusi',
      workarea: 'Area Kerja',
    },
    elements_panel: {
      animals: 'Hewan',
      arrow: 'Panah',
      avatar: 'Gambar avatarnya',
      basic: 'Dasar',
      birds: 'Burung',
      browse_categories: 'Telusuri Kategori',
      celebration: 'Perayaan',
      circular: 'Lingkaran',
      cleaning_tools: 'Alat pembersih',
      CNY: 'Tahun Baru Imlek',
      corner: 'Sudut',
      decor: 'Dekorasi',
      doctor: 'Dokter',
      easter: 'Paskah',
      elements: 'Elemen',
      environment: 'Lingkungan',
      gardening_tools: 'Alat berkebun',
      graphics: 'Grafis',
      halloween: 'Halloween',
      hammer_wrench: 'Palu dan kunci pas',
      heart: 'Hati',
      holidays: 'Liburan',
      insect: 'Serangga',
      kitchen_tools: 'Peralatan dapur',
      label: 'Label',
      land: 'Daratan',
      line: 'Garis',
      load_more: 'Muat 100 hasil berikutnya',
      nature: 'Alam',
      people: 'Orang',
      photo: 'Foto',
      plants: 'Tanaman',
      police: 'Polisi',
      recently_used: 'Baru-baru ini digunakan',
      ribbon: 'Pita',
      sea: 'Laut',
      search_examples: 'Contoh:',
      search_invalid_characters: 'Karakter tidak valid digunakan.',
      search_no_results: 'Tidak ditemukan hasil untuk "%s". Harap periksa ejaan atau coba kata kunci lain.',
      search_with_english: 'Hanya huruf Inggris, angka, koma, dan spasi yang diperbolehkan.',
      shape: 'Bentuk',
      sign_in: 'Masuk untuk mendapatkan lebih dari 10.000 ikon gratis',
      speech: 'Pidato',
      student: 'Mahasiswa',
      study_tools: 'Alat belajar',
      teacher: 'Guru',
      text: 'Teks',
      title: 'Elemen',
      tools: 'Alat',
      valentines: 'Valentine',
      weather: 'Cuaca',
      Xmas: 'Natal',
      zodiac: 'Zodiak',
    },
    image_trace_panel: {
      back: 'Kembali',
      brightness: 'Kecerahan',
      cancel: 'Batal',
      contrast: 'Kontras',
      next: 'Berikutnya',
      okay: 'Oke',
      threshold: 'Ambang',
      tuning: 'Parameter',
    },
    layer_color_config_panel: {
      add: 'Tambah',
      add_config: 'Tambah Warna',
      color: 'Warna',
      default: 'Setel Ulang Ke Default',
      in_use: 'Warna ini sedang digunakan.',
      layer_color_config: 'Konfigurasi Warna Lapisan',
      no_input: 'Harap masukkan kode warna heksadesimal yang valid.',
      power: 'Daya',
      repeat: 'Eksekusi',
      speed: 'Kecepatan',
      sure_to_delete: 'Apakah Anda yakin untuk menghapus pengaturan warna ini?',
      sure_to_reset: 'Anda akan kehilangan semua parameter yang disesuaikan, apakah Anda yakin untuk menyetel ulang ke default?',
    },
    left_panel: {
      borderless_blind_area: 'Area Non-ukir',
      borderless_preview: 'Pratinjau Kamera Mode Bawah Terbuka',
      diode_blind_area: 'Area Buta Tambahan Laser Hibrid',
      label: {
        adjust_height: 'Sesuaikan Tinggi',
        array: 'Larik',
        boxgen: 'Boxgen',
        choose_camera: 'Kamera',
        clear_preview: 'Hapus Pratinjau',
        cursor: 'Pilih',
        curve_engraving: {
          clear_area: 'Hapus Area yang Dipilih',
          exit: 'Keluar',
          preview_3d_curve: 'Pratinjau Ukiran Kurva',
          select_area: 'Pilih area',
          title: 'Ukiran Kurva',
        },
        elements: 'Bentuk',
        end_preview: 'Akhiri Pratinjau',
        fit_text: 'Kotak Teks',
        line: 'Garis',
        live_feed: 'Siaran Langsung',
        my_cloud: 'Awan Saya',
        oval: 'Lingkaran',
        pass_through: 'Lewat langsung',
        pen: 'Pen',
        photo: 'Gambar',
        polygon: 'Poligon',
        preview: 'Pratinjau Kamera',
        preview_precise: 'Pratinjau kamera presisi',
        preview_wide_angle: 'Pratinjau kamera sudut lebar',
        qr_code: 'Kode QR',
        rect: 'Persegi Panjang',
        text: 'Teks',
        trace: 'Jejak Gambar',
      },
      unpreviewable_area: 'Area Buta',
    },
    network_testing_panel: {
      average_response: 'Rata-rata Waktu Respon',
      cannot_connect_1: '#840 Gagal terhubung ke IP target.',
      cannot_connect_2: '#840 Gagal terhubung ke IP target. Pastikan target berada di jaringan yang sama.',
      cannot_get_local: 'Akses ke alamat IP lokal gagal.',
      connection_quality: 'Kualitas Koneksi',
      device_not_on_list: '#842 Mesin tidak ada di daftar, tetapi Kualitas koneksi >70 dan rata-rata waktu respon <100ms',
      empty_ip: '#818 Mohon masukkan alamat IP perangkat target terlebih dahulu.',
      end: 'Selesai',
      fail_to_start_network_test: '#817 Gagal memulai pengujian jaringan.',
      hint_connect_camera_timeout: 'Timeout terjadi saat memulai pratinjau kamera?',
      hint_connect_failed_when_sending_job: 'Gagal terhubung saat mengirim pekerjaan?',
      hint_device_often_on_list: 'Mesin sering tidak ditemukan di daftar?',
      insert_ip: 'Alamat IP perangkat target:',
      invalid_ip: '#818 Alamat IP tidak valid',
      ip_startswith_169: '#843 Alamat IP mesin dimulai dengan 169.254',
      link_connect_camera_timeout: 'https://support.flux3dp.com/hc/en-us/articles/360001791895',
      link_connect_failed_when_sending_job: 'https://support.flux3dp.com/hc/en-us/articles/360001841656',
      link_device_often_on_list: 'https://support.flux3dp.com/hc/en-us/articles/360001841636',
      linux_permission_hint: 'Kesalahan ini biasanya terjadi karena izin yang tidak memadai.\nHarap jalankan "sudo beam-studio --no-sandbox" di terminal untuk mendapatkan izin dan melakukan pengujian jaringan.',
      local_ip: 'Alamat IP lokal:',
      network_testing: 'Pengujian Jaringan',
      network_unhealthy: '#841 Kualitas koneksi <70 atau rata-rata waktu respon >100ms',
      start: 'Mulai',
      test_completed: 'Pengujian Selesai',
      test_fail: 'Pengujian Gagal',
      testing: 'Menguji Jaringan...',
    },
    object_panels: {
      lock_desc: 'Jaga rasio lebar dan tinggi (SHIFT)',
      text_to_path: {
        check_thumbnail_warning: 'Beberapa teks diubah ke font lain saat mengubah teks ke path dan beberapa karakter mungkin tidak dikonversi dengan normal.\nPeriksa gambar pratinjau lagi sebelum mengirim tugas.',
        error_when_parsing_text: 'Kesalahan saat mengubah teks ke path',
        font_substitute_pop: 'Teks Anda berisi karakter yang tidak didukung oleh font saat ini. <br/>Apakah Anda ingin menggunakan <strong>%s</strong> sebagai pengganti?',
        retry: 'Coba lagi nanti atau pilih font lain',
        use_current_font: 'Gunakan Font Saat Ini',
      },
      wait_for_parsing_font: 'Mengurai font... Mohon tunggu sebentar',
    },
    path_preview: {
      current_position: 'Posisi Saat Ini',
      cut_distance: 'Jarak Pemotongan',
      cut_time: 'Waktu Pemotongan',
      end_preview: 'Selesai Pratinjau',
      estimated_time: 'Total Waktu Perkiraan',
      invert: 'Balik',
      pause: 'Jeda',
      play: 'Mainkan',
      play_speed: 'Kecepatan Pemutaran',
      preview_info: 'Pratinjau Informasi',
      rapid_distance: 'Jarak Perjalanan',
      rapid_time: 'Waktu Perjalanan',
      remark: '* Semua informasi adalah nilai perkiraan untuk referensi.',
      size: 'Ukuran',
      start_here: 'Mulai Di Sini',
      stop: 'Berhenti',
      travel_path: 'Lintasan Perjalanan',
    },
    photo_edit_panel: {
      aspect_ratio: 'Rasio Aspek',
      brightness: 'Kecerahan',
      brightness_and_contrast: 'Kecerahan / Kontras',
      circumference: 'Keliling',
      compare: 'Bandingkan',
      contrast: 'Kontras',
      crop: 'Potong',
      curve: 'Lengkungan',
      diameter: 'Diameter',
      free: 'Bebas',
      invert: 'Balik Warna',
      original: 'Asli',
      phote_edit: 'Edit Foto',
      processing: 'Memproses',
      radius: 'Jari-jari',
      rotary_warped: 'Berputar Melengkung',
      rotary_warped_link: 'https://support.flux3dp.com/hc/en-us/articles/10828006201103',
      sharpen: 'Tajamkan',
      sharpness: 'Ketajaman',
      start: 'Mulai',
      warp: 'Melengkung',
    },
    popup: {
      ai_credit: {
        buy_link: 'https://member.flux3dp.com/en-US/credit',
        insufficient_credit: 'Kredit Tidak Cukup',
        insufficient_credit_msg: 'Fitur ini memerlukan %s Kredit AI, tetapi Anda hanya memiliki %s Kredit AI tersisa.\nSilakan beli lebih banyak kredit dan coba lagi.',
        relogin_to_use: 'Silakan login ulang untuk menggunakan fitur ini.',
      },
      auto_feeder_origin: 'Gunakan pratinjau pembingkaian untuk memeriksa jalur dan area kepala laser, lalu sesuaikan posisi material atau posisi mulai ukiran berdasarkan hasil untuk menghindari tabrakan selama proses pengukiran.',
      auto_switch_tab: {
        message: 'Opsi baru untuk beralih secara otomatis antara panel Lapisan dan panel Objek telah ditambahkan ke Preferensi. Opsi ini dinonaktifkan secara default. Apakah Anda ingin mengaktifkan pengalihan otomatis sekarang? <br/>Anda dapat mengubah pengaturan ini kapan saja di Preferensi.',
        title: 'Pengalihan Otomatis Panel Lapisan dan Objek',
      },
      backend_connect_failed_ask_to_upload: '#802 Kesalahan terus terjadi saat mencoba terhubung ke backend. Apakah Anda ingin mengunggah log laporan bug Anda?',
      backend_error_hint: 'Fitur mungkin tidak berfungsi dengan benar karena kesalahan backend.',
      both_power_and_speed_too_high: 'Menggunakan daya laser lebih rendah akan memperpanjang umur tabung laser. Juga, kecepatan terlalu tinggi pada resolusi ini dapat mengurangi kualitas ukiran bayangan.',
      bug_report: 'Laporan Bug',
      change_workarea_before_preview: 'Area kerja %s tidak cocok dengan area kerja yang saat ini diatur. Apakah Anda ingin beralih area kerja saat ini?',
      convert_to_path_fail: 'Gagal mengubah ke jalur.',
      disassemble_use: {
        clip_path_warning: 'File ini mengandung clipping mask dan tidak dapat dibongkar.',
        execute_time_warning: 'Ini akan membatalkan pengelompokan DXF atau SVG yang diimpor. Karena file mungkin berisi sejumlah besar elemen, mungkin memerlukan waktu untuk membatalkan pengelompokan. Apakah Anda yakin untuk melanjutkan?',
      },
      dxf_bounding_box_size_over: 'Ukuran gambar melebihi area kerja. Harap pindahkan gambar Anda lebih dekat ke asal dalam perangkat lunak CAD Anda, atau pastikan bahwa unit diatur dengan benar.',
      dxf_paste_failed: 'Gagal menempelkan DXF dari papan klip. Pastikan konten yang disalin adalah DXF yang valid.',
      dxf_version_waring: 'Versi file DXF ini bukan 2013, mungkin ada masalah kompatibilitas potensial.',
      facebook_group_invitation: {
        already_joined: 'Sudah Bergabung',
        join_now: 'Gabung Sekarang',
        later: 'Mungkin Nanti',
        message: 'Bergabunglah dengan grup Facebook resmi kami untuk terhubung dengan pengguna laser FLUX lainnya, membahas laser FLUX, berbagi karya seni laser, dan tetap update dengan pembaruan terbaru pada produk kami. Kami tidak sabar melihat Anda di sana!',
        title: 'Bergabung dengan Grup Pengguna Resmi FLUX',
      },
      failed_to_load_svg: 'Tidak dapat memuat data SVG',
      import_file_contain_invalid_path: '#808 File SVG yang diimpor berisi path gambar yang tidak valid. Pastikan semua file gambar ada atau sisipkan gambar dalam file',
      import_file_error_ask_for_upload: 'Gagal mengimpor file SVG. Apakah Anda bersedia memberikan file ke tim pengembang untuk laporan bug ?',
      import_svg: {
        advice_message: 'Ini dapat menyebabkan lag serius atau kegagalan impor.',
        advice_message_2: 'Disarankan untuk menyederhanakan file sebelum mengimpor.',
        confirmation_message: 'Apakah Anda ingin melanjutkan?',
        element_count_warning: 'Jumlah elemen: %s (Disarankan: < %s).',
        file_size_warning: 'Ukuran file: %sMB (Disarankan: < %sMB).',
        intro_message: 'File mungkin terlalu besar atau kompleks:',
        path_d_command_count_warning: 'Jumlah perintah: %s (Disarankan: < %s).',
        title: 'Peringatan Impor File',
      },
      layer_by_color: 'Warna',
      layer_by_layer: 'Lapisan',
      loading_image: 'Memuat gambar, harap tunggu...',
      more_than_two_object: 'Terlalu banyak objek. Hanya mendukung 2 objek',
      mouse: 'Mouse',
      no_curve_engraving_with_modules: 'Pekerjaan ini mencakup pengukiran permukaan melengkung, yang tidak dapat digunakan bersamaan dengan pencetakan berwarna. Harap matikan lapisan pencetakan warna dan kirim ulang pekerjaan.',
      no_support_text: 'Beam Studio saat ini tidak mendukung teks. Harap ubah teks ke path sebelum mengimpor.',
      nolayer: 'Lapisan Tunggal',
      not_support_object_type: 'Tidak mendukung jenis objek',
      or_turn_off_borderless_mode: 'Atau matikan mode Open Bottom.',
      path_engine_upgrade: {
        caption: 'Pembuatan Pekerjaan Lebih Cepat Tersedia',
        keep_current: 'Pertahankan Saat Ini',
        message: 'Kami telah meningkatkan mesin perhitungan pekerjaan untuk meningkatkan kinerja dan mempercepat pembuatan pekerjaan.\nApakah Anda ingin beralih ke mesin yang dipercepat baru?\nAnda dapat menonaktifkannya kapan saja di %(preferences)s > %(editor)s > %(path_acceleration)s.',
      },
      pdf2svg: {
        error_pdf2svg_not_found: '#825 Kesalahan: Perintah pdf2svg tidak ditemukan. Harap pasang pdf2svg dengan manajer paket Anda (mis. "yum install pdf2svg" atau "apt-get install pdf2svg").',
        error_when_converting_pdf: '#824 Kesalahan saat mengonversi PDF ke SVG:',
      },
      progress: {
        calculating: 'Menghitung',
        uploading: 'Mengunggah',
      },
      questionnaire: {
        caption: 'Bantu Kami Mengisi Kuesioner',
        message: 'Bantu kami mengisi kuesioner untuk membuat Beam Studio lebih baik.',
        no_questionnaire_available: 'Saat ini tidak ada kuesioner yang tersedia.',
        unable_to_get_url: 'Gagal mendapatkan tautan ke kuesioner melalui internet. Harap konfirmasi koneksi internet Anda.',
      },
      reach_tab_count_limit: 'Batas jumlah tab telah tercapai',
      recommend_downgrade_software: 'Kami mendeteksi versi firmware yang lebih lama. Kami sedang menangani masalah kompatibilitas, tetapi untuk saat ini, kami menyarankan kembali ke <a target="_blank" href="https://beamstudio.s3.ap-northeast-1.amazonaws.com/mac/Beam+Studio+1.9.5.dmg">Beam Studio 1.9.5</a>.',
      recommend_upgrade_firmware: 'Kami mendeteksi versi firmware yang lebih lama. Kami sedang menangani masalah kompatibilitas, tetapi untuk saat ini, kami menyarankan memperbarui ke firmware terbaru.',
      save_unsave_changed: 'Apakah Anda ingin menyimpan perubahan yang belum disimpan?',
      select_at_least_two: 'Pilih dua objek untuk melanjutkan',
      select_first: 'Pilih objek terlebih dahulu.',
      select_import_method: 'Pilih gaya pelapisan:',
      select_import_module: 'Pilih Modul:',
      sentry: {
        message: 'Apakah Anda setuju untuk secara otomatis mengunggah informasi yang relevan ke tim pengembangan ketika terjadi kesalahan?',
        title: 'Mari kita membuat Beam Studio lebih baik bersama',
      },
      should_update_firmware_to_continue: '#814 Firmware Anda tidak mendukung versi Beam Studio ini. Harap perbarui firmware untuk melanjutkan. (Menu > Mesin > [Mesin Anda] > Perbarui Firmware)',
      speed_too_high_lower_the_quality: 'Menggunakan kecepatan terlalu tinggi pada resolusi ini dapat mengurangi kualitas ukiran bayangan.',
      still_continue: 'Lanjutkan',
      successfully_uploaded: 'Unggah file berhasil.',
      svg_1_1_waring: 'Versi file SVG ini adalah v 1.1, mungkin ada masalah kompatibilitas potensial.',
      svg_image_path_waring: 'File SVG ini berisi <image> memuat dari jalur file. Ini mungkin menyebabkan kegagalan saat memuat.\nUntuk menghindari risiko ini, mohon gunakan gambar yang disematkan saat mengekspor SVG.',
      text_to_path: {
        caption: 'Konverter Teks ke Jalur 2.0',
        message: "Beam Studio sekarang memperkenalkan konverter teks ke jalur yang baru (Konverter 2.0), yang menghasilkan hasil yang lebih andal! Apakah Anda ingin beralih ke sana sekarang? \nAnda juga dapat menyesuaikan pengaturan ini nanti di bagian 'Konverter Teks ke Jalur' dalam preferensi.",
      },
      too_fast_for_auto_feeder: 'Menggunakan kecepatan yang terlalu tinggi pada lapisan yang berisi objek jalur dapat mengurangi ketelitian saat pemotongan.\nKami tidak menyarankan menggunakan kecepatan lebih dari %(limit)s saat memotong dengan Auto Feeder.',
      too_fast_for_auto_feeder_and_constrain: 'Lapisan berikut: %(layers)s \nmemuat objek jalur vektor dan memiliki kecepatan yang melebihi %(limit)s.\nKecepatan pemotongan untuk objek jalur vektor dengan Auto Feeder akan dibatasi pada %(limit)s.\nAnda dapat menghapus batas ini di Pengaturan Preferensi.',
      too_fast_for_curve: 'Dalam mode ukiran lengkung, kecepatan saat ini mungkin terlalu tinggi dan dapat memengaruhi detail ukiran untuk lapisan: %(layers)s.\nPertimbangkan untuk mengurangi kecepatan untuk kualitas yang lebih baik.',
      too_fast_for_path: 'Menggunakan kecepatan terlalu tinggi pada lapisan yang berisi objek path dapat mengurangi presisi saat pemotongan. Kami tidak menyarankan menggunakan kecepatan lebih dari %(limit)s saat pemotongan.',
      too_fast_for_path_and_constrain: 'Lapisan berikut: %(layers)s \nberisi objek path vektor, dan memiliki kecepatan melebihi %(limit)s. Kecepatan pemotongan objek path vektor akan dibatasi hingga %(limit)s. Anda dapat menghapus batasan ini di Pengaturan Preferensi.',
      touchpad: 'TouchPad',
      upload_failed: '#819 Unggah file gagal.',
      upload_file_too_large: '#819 File terlalu besar untuk diunggah.',
      vectorize_shading_image: 'Gambar gradien memerlukan waktu lebih lama untuk melacak dan rentan terhadap noise. Harap matikan gradien gambar sebelum mengeksekusi.',
    },
    rating_panel: {
      description: 'Jika Anda menyukai Beam Studio, kami akan sangat menghargai jika Anda dapat memberi penilaian.',
      thank_you: 'Terima kasih!',
      title: 'Menikmati Beam Studio?',
    },
    right_panel: {
      laser_panel: {
        advanced: 'Lanjutan',
        air_assist: 'Bantuan udara',
        am_density: 'Kepadatan titik raster',
        backlash: 'Backlash',
        bi_directional: 'Dua Arah',
        by: 'Sebesar',
        ce_z_high_speed: 'Sumbu Z kecepatan tinggi',
        ce_z_high_speed_link: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
        color_adjustment: 'Penyesuaian Saluran',
        color_adjustment_short: 'Saluran',
        color_strength: 'Kekuatan',
        cross_hatch: 'Arsir Silang',
        custom_preset: 'Kustom',
        cut: 'Potong',
        diode: 'Laser Diode',
        do_not_adjust_default_para: 'Preset tidak dapat disesuaikan.',
        dottingTime: 'Waktu Penandaan',
        dropdown: {
          inches: {
            abs_engraving: 'ABS - Pengukiran',
            acrylic_3mm_cutting: 'Akrilik - 1/8″ Potong',
            acrylic_5mm_cutting: 'Akrilik - 3/16″ Potong',
            acrylic_7mm_cutting: 'Akrilik - 1/4″ Potong',
            acrylic_8mm_cutting: 'Akrilik - 1/4″ Potong',
            acrylic_10mm_cutting: 'Akrilik - 3/8″ Potong',
            acrylic_engraving: 'Akrilik - Pengukiran',
            acrylic_printing: 'Akrilik - Cetak',
            aluminum_engraving: 'Aluminium - Pengukiran',
            aluminum_light: 'Aluminium (terang)',
            bamboo_2mm_cutting: 'Bambu - 5/64″ Potong',
            bamboo_5mm_cutting: 'Bambu - 3/16″ Potong',
            bamboo_printing: 'Bambu - Cetak',
            black_abs: 'ABS Hitam',
            black_acrylic_3mm_cutting: 'Akrilik Hitam - 1/8″ Potong',
            black_acrylic_5mm_cutting: 'Akrilik Hitam - 3/16″ Potong',
            black_acrylic_engraving: 'Akrilik Hitam - Pengukiran',
            brass_dark: 'Kuningan (gelap)',
            brass_engraving: 'Kuningan - Pengukiran',
            brass_light: 'Kuningan (terang)',
            canvas_fabric_printing: 'Kain Kanvas - Cetak',
            canvas_printing: 'Kanvas - Cetak',
            cardboard_printing: 'Kardus - Cetak',
            cardstock_printing: 'Karton Tebal - Cetak',
            copper: 'Tembaga',
            cork_printing: 'Gabus - Cetak',
            denim_1mm_cutting: 'Denim - 1/32″ Potong',
            fabric_3mm_cutting: 'Kain - 1/8″ Potong',
            fabric_5mm_cutting: 'Kain - 3/16″ Potong',
            fabric_engraving: 'Kain - Pengukiran',
            fabric_printing: 'Kain - Cetak',
            flat_stone_printing: 'Batu Datar - Cetak',
            glass_bw_engraving: 'Kaca - Pengukiraniran',
            glass_printing: 'Kaca - Cetak',
            gloss_leather_printing: 'Kulit Glossy - Cetak',
            gold_engraving: 'Emas - Pengukiran',
            iron_engraving: 'Besi - Pengukiran',
            leather_3mm_cutting: 'Kulit - 1/8″ Potong',
            leather_5mm_cutting: 'Kulit - 3/16″ Potong',
            leather_engraving: 'Kulit - Pengukiran',
            leather_printing: 'Kulit - Cetak',
            mdf_3mm_cutting: 'MDF - 1/8″ Potong',
            mdf_5mm_cutting: 'MDF - 3/16″ Potong',
            mdf_7mm_cutting: 'MDF - 1/4″ Potong',
            mdf_engraving: 'MDF - Pengukiran',
            mdf_printing: 'MDF - Cetak',
            metal_bw_engraving: 'Logam - Pengukiran',
            opaque_acrylic: 'Akrilik buram',
            pc_printing: 'PC - Cetak',
            rubber_bw_engraving: 'Karet - Pengukiran',
            silver_engraving: 'Perak - Pengukiran',
            slate_engraving: 'Batu sabak - Pengukiran',
            stainless_steel_bw_engraving_diode: 'Logam - Pengukiran (Laser Diode)',
            stainless_steel_dark: 'Baja tahan karat (gelap)',
            stainless_steel_engraving: 'Baja Tahan Karat - Pengukiran',
            stainless_steel_light: 'Baja tahan karat (terang)',
            stainless_steel_printing: 'Baja Tahan Karat - Cetak',
            steel_engraving_spray_engraving: 'Logam - Pengukiran',
            sticker_kiss_cut: 'Stiker – potong setengah lapisan',
            sticker_printing: 'Stiker - Cetak',
            stone: 'Batu',
            ti_engraving: 'Titanium - Pengukiran',
            titanium_dark: 'Titanium (gelap)',
            titanium_light: 'Titanium (terang)',
            white_abs: 'ABS Putih',
            wood_3mm_cutting: 'Kayu - 1/8″ Potong',
            wood_5mm_cutting: 'Kayu - 3/16″ Potong',
            wood_7mm_cutting: 'Kayu - 1/4″ Potong',
            wood_8mm_cutting: 'Kayu - 1/4″ Potong',
            wood_10mm_cutting: 'Kayu - 3/8″ Potong',
            wood_engraving: 'Kayu - Pengukiran',
            wood_printing: 'Kayu - Cetak',
          },
          mm: {
            abs_engraving: 'ABS - Pengukiran',
            acrylic_3mm_cutting: 'Akrilik - 3mm Potong',
            acrylic_5mm_cutting: 'Akrilik - 5mm Potong',
            acrylic_7mm_cutting: 'Akrilik - 7mm Potong',
            acrylic_8mm_cutting: 'Akrilik - 8mm Potong',
            acrylic_10mm_cutting: 'Akrilik - 10mm Potong',
            acrylic_engraving: 'Akrilik - Pengukiran',
            acrylic_printing: 'Akrilik - Cetak',
            aluminum_engraving: 'Aluminium - Pengukiran',
            aluminum_light: 'Aluminium (terang)',
            bamboo_2mm_cutting: 'Bambu - 2mm Potong',
            bamboo_5mm_cutting: 'Bambu - 5mm Potong',
            bamboo_printing: 'Bambu - Cetak',
            black_abs: 'ABS Hitam',
            black_acrylic_3mm_cutting: 'Akrilik Hitam - 3mm Potong',
            black_acrylic_5mm_cutting: 'Akrilik Hitam - 5mm Potong',
            black_acrylic_engraving: 'Akrilik Hitam - Pengukiran',
            brass_dark: 'Kuningan (gelap)',
            brass_engraving: 'Perunggu - Pengukiran',
            brass_light: 'Kuningan (terang)',
            canvas_fabric_printing: 'Kain Kanvas - Cetak',
            canvas_printing: 'Kanvas - Cetak',
            cardboard_printing: 'Kardus - Cetak',
            cardstock_printing: 'Karton Tebal - Cetak',
            copper: 'Tembaga',
            cork_printing: 'Gabus - Cetak',
            denim_1mm_cutting: 'Denim - 1mm Potong',
            fabric_3mm_cutting: 'Kain - 3mm Potong',
            fabric_5mm_cutting: 'Kain - 5mm Potong',
            fabric_engraving: 'Kain - Pengukiran',
            fabric_printing: 'Kain - Cetak',
            flat_stone_printing: 'Batu Datar - Cetak',
            glass_bw_engraving: 'Kaca - Pengukiraniran',
            glass_printing: 'Kaca - Cetak',
            gloss_leather_printing: 'Kulit Glossy - Cetak',
            gold_engraving: 'Emas - Pengukiran',
            iron_engraving: 'Besi - Pengukiran',
            leather_3mm_cutting: 'Kulit - 3mm Potong',
            leather_5mm_cutting: 'Kulit - 5mm Potong',
            leather_engraving: 'Kulit - Pengukiran',
            leather_printing: 'Kulit - Cetak',
            mdf_3mm_cutting: 'MDF - 3mm Potong',
            mdf_5mm_cutting: 'MDF - 5mm Potong',
            mdf_7mm_cutting: 'MDF - 7mm Potong',
            mdf_engraving: 'MDF - Pengukiran',
            mdf_printing: 'MDF - Cetak',
            metal_bw_engraving: 'Logam - Pengukiran',
            opaque_acrylic: 'Akrilik buram',
            pc_printing: 'PC - Cetak',
            rubber_bw_engraving: 'Karet - Pengukiran',
            silver_engraving: 'Perak - Pengukiran',
            slate_engraving: 'Batu sabak - Pengukiran',
            stainless_steel_bw_engraving_diode: 'Baja Tahan Karat - Pengukiran (Laser Diode)',
            stainless_steel_dark: 'Baja tahan karat (gelap)',
            stainless_steel_engraving: 'Baja Tahan Karat - Pengukiran',
            stainless_steel_light: 'Baja tahan karat (terang)',
            stainless_steel_printing: 'Baja Tahan Karat - Cetak',
            steel_engraving_spray_engraving: 'Logam - Pengukiran',
            sticker_kiss_cut: 'Stiker – potong setengah lapisan',
            sticker_printing: 'Stiker - Cetak',
            stone: 'Batu',
            ti_engraving: 'Titanium - Pengukiran',
            titanium_dark: 'Titanium (gelap)',
            titanium_light: 'Titanium (terang)',
            white_abs: 'ABS Putih',
            wood_3mm_cutting: 'Kayu - 3mm Potong',
            wood_5mm_cutting: 'Kayu - 5mm Potong',
            wood_7mm_cutting: 'Kayu - 7mm Potong',
            wood_8mm_cutting: 'Kayu - 8mm Potong',
            wood_10mm_cutting: 'Kayu - 10mm Potong',
            wood_engraving: 'Kayu - Pengukiran',
            wood_printing: 'Kayu - Cetak',
          },
          parameters: 'Preset',
          save: 'Tambahkan parameter saat ini',
        },
        engrave: 'Ukir',
        existing_name: 'Nama ini sudah digunakan.',
        fill_angle: 'Sudut Isian',
        fill_interval: 'Jarak Isian',
        fill_setting: 'Pengaturan Isi',
        filled_path_only: 'Hanya untuk jalur isian',
        focus_adjustment: 'Penyesuaian Fokus',
        frequency: 'Frekuensi',
        gradient_only: 'Hanya untuk gambar gradasi',
        halftone: 'Setengah tone',
        halftone_link: 'https://support.flux3dp.com/hc/en-us/articles/9402670389647',
        height: 'Tinggi Objek',
        high_quality: 'Kualitas Tinggi',
        high_quality_desc: 'Hanya berlaku untuk pengukiran vektor yang diisi dan objek gambar. Mengaktifkan ini akan mengurangi akselerasi pengukiran untuk hasil yang lebih halus.',
        ink_saturation: 'Saturasi',
        low_air_assist_warning: 'Disarankan untuk mengatur bantuan udara di atas 50% untuk secara efektif mengurangi risiko bahan terbakar.',
        low_power_warning: 'Daya laser yang lebih rendah (di bawah 10%) mungkin tidak memancarkan cahaya laser.',
        low_speed_warning: 'Kecepatan rendah dapat menyebabkan pembakaran bahan.',
        lower_focus: 'Turunkan Fokus',
        lower_focus_desc: 'Menurunkan ketinggian fokus dengan jarak tertentu setelah fokus untuk meningkatkan kinerja pemotongan.',
        module: 'Modul',
        more: 'Kelola',
        multi_layer: 'Beberapa Lapisan',
        para_in_use: 'Parameter ini sedang digunakan.',
        parameters: 'Parameter',
        preset_management: {
          add_new: 'Tambahkan Baru',
          delete: 'Hapus',
          export: 'Ekspor',
          export_preset_title: 'Ekspor Preset',
          import: 'Impor',
          laser: 'Laser',
          lower_focus_by: 'Turunkan Fokus dengan',
          new_preset_name: 'Nama Preset Baru',
          preset: 'Prasetel',
          print: 'Cetak',
          reset: 'Atur Ulang',
          save_and_exit: 'Simpan dan Keluar',
          show_all: 'Tampilkan Semua',
          sure_to_import_presets: 'Ini akan memuat susunan prasetel dan menimpa parameter yang Anda sesuaikan, apakah Anda yakin ingin melanjutkan?',
          sure_to_reset: 'Ini akan menghapus parameter yang Anda sesuaikan dan mengatur ulang semua prasetel, apakah Anda yakin ingin melanjutkan?',
          title: 'Kelola Parameter',
          wobble_diameter: 'Diameter goyangan',
          wobble_step: 'Ukuran langkah goyangan',
        },
        preset_setting: 'Pengaturan Parameter (%s)',
        presets: 'Preset',
        print_multipass: 'Multi-pass',
        promark_speed_desc: 'Parameter kecepatan tidak berlaku untuk gambar gradasi.',
        pulse_width: 'Lebar Denyut',
        pwm_advanced_desc: 'Tetapkan daya minimum untuk mode kedalaman.',
        pwm_advanced_hint: 'Pengaturan ini berlaku khusus untuk gambar gradasi saat menggunakan mode kedalaman.',
        pwm_advanced_setting: 'Pengaturan Daya Mode Kedalaman',
        refresh_interval: 'Interval penyegaran',
        refresh_printer: 'Penyegaran printhead',
        repeat: 'Jumlah Lintasan',
        single_color: 'Warna Tunggal',
        single_color_desc: 'Hanya berlaku untuk lapisan warna penuh dan tidak dapat digunakan dengan lapisan warna tunggal yang diperluas.',
        slider: {
          fast: 'Cepat',
          high: 'Tinggi',
          low: 'Rendah',
          regular: 'Reguler',
          slow: 'Lambat',
          very_fast: 'Paling Cepat',
          very_high: 'Maksimal',
          very_low: 'Minimal',
          very_slow: 'Paling Lambat',
        },
        speed: 'Kecepatan',
        speed_constrain_warning: 'Kecepatan pemotongan path vector akan dibatasi hingga %(limit)s. Anda dapat menghapus batasan ini di Pengaturan Preferensi.',
        speed_constrain_warning_auto_feeder: 'Kecepatan pemotongan objek Pengumpan Otomatis akan dibatasi hingga %(limit)s. Anda dapat menghapus batas ini di Pengaturan Preferensi.',
        speed_constrain_warning_curve_engraving: 'Kecepatan ukiran objek lengkung akan dibatasi hingga %(limit)s. Anda dapat menghapus batas ini di Pengaturan Preferensi.',
        speed_constrain_warning_module_addon: 'Saat menggunakan modul tambahan, hindari kecepatan di atas %(limit)s untuk menjaga kualitas ukiran.',
        stepwise_focusing: 'Pemfokusan Bertahap',
        stepwise_focusing_desc: 'Menurunkan jarak fokus secara bertahap berdasarkan tinggi objek selama setiap hitungan lintasan.',
        strength: 'Daya',
        times: 'kali',
        various_preset: 'Berbagai Preset',
        white_ink: 'Tinta Putih',
        white_ink_settings: 'Pengaturan Tinta Putih',
        wobble: 'Goyangan',
        wobble_desc: 'Membuat lingkaran kecil di sepanjang jalur, yang bermanfaat untuk tugas pemotongan. (Hanya untuk objek jalur.)',
        wobble_diameter: 'Diameter',
        wobble_step: 'Ukuran langkah',
        z_step: 'Langkah Z',
      },
      layer_panel: {
        current_layer: 'Lapisan Saat Ini',
        layer1: 'Lapisan 1',
        layer_bitmap: 'Bitmap',
        layer_cutting: 'Pemotongan',
        layer_engraving: 'Pengukiran',
        layers: {
          del: 'Hapus Lapisan',
          dupe: 'Duplikat Lapisan',
          fullColor: 'Warna penuh',
          layer: 'Lapisan',
          layers: 'Lapisan',
          lock: 'Kunci Lapisan',
          merge_all: 'Gabung Semua',
          merge_down: 'Gabung Ke Bawah',
          merge_selected: 'Gabung Lapisan Terpilih',
          move_down: 'Pindahkan Lapisan Ke Bawah',
          move_selected: 'Pindahkan elemen terpilih ke lapisan yang berbeda',
          move_up: 'Pindahkan Lapisan Ke Atas',
          new: 'Lapisan Baru',
          rename: 'Ubah Nama Lapisan',
          splitFullColor: 'Perluas Lapisan',
          switchToFullColor: 'Alihkan ke lapisan warna penuh',
          switchToSingleColor: 'Alihkan ke lapisan warna tunggal',
          unlock: 'Buka Kunci',
        },
        move_elems_to: 'Pindahkan elemen ke:',
        notification: {
          dupeLayerName: 'Sudah ada lapisan dengan nama itu!',
          enterNewLayerName: 'Silakan masukkan nama lapisan baru',
          enterUniqueLayerName: 'Silakan masukkan nama lapisan yang unik',
          layerHasThatName: 'Lapisan sudah memiliki nama itu',
          mergeLaserLayerToPrintingLayerMsg: 'Harap perhatikan bahwa jika Anda menyelesaikan operasi ini, pengaturan lapisan laser akan dihapus dan diatur sesuai dengan lapisan saat ini.',
          mergeLaserLayerToPrintingLayerTitle: 'Apakah Anda ingin menggabungkan lapisan ini menjadi satu lapisan Pencetakan?',
          mergePrintingLayerToLaserLayerMsg: 'Harap perhatikan bahwa jika Anda menyelesaikan operasi ini, pengaturan warna lapisan pencetakan akan dihapus dan diatur sesuai dengan lapisan saat ini.',
          mergePrintingLayerToLaserLayerTitle: 'Apakah Anda ingin menggabungkan lapisan ini menjadi satu lapisan Laser?',
          moveElemFromPrintingLayerMsg: 'Harap perhatikan bahwa jika Anda menyelesaikan operasi ini, pengaturan warna dari elemen terpilih akan dihapus dan diatur sesuai dengan %s.',
          moveElemFromPrintingLayerTitle: 'Pindahkan elemen terpilih ke %s dan ubah menjadi elemen laser?',
          moveElemToPrintingLayerMsg: 'Harap perhatikan bahwa jika Anda menyelesaikan operasi ini, pengaturan dari elemen terpilih akan dihapus dan diatur sesuai dengan %s.',
          moveElemToPrintingLayerTitle: 'Pindahkan elemen terpilih ke %s dan ubah menjadi elemen pencetakan?',
          newName: 'NAMA BARU',
          QmoveElemsToLayer: "Pindahkan elemen terpilih ke lapisan '%s'?",
          splitColorMsg: 'Harap perhatikan bahwa jika Anda melanjutkan operasi ini, Anda tidak akan dapat kembali ke lapisan warna asli.',
          splitColorTitle: 'Apakah Anda ingin memperluas lapisan terpilih menjadi lapisan CMYK?',
        },
      },
      object_panel: {
        actions_panel: {
          ai_bg_removal: 'Hapus Latar Belakang',
          ai_bg_removal_reminder: 'Menekan tombol akan segera menggunakan 0,02 Kredit, apakah Anda ingin melanjutkan?',
          ai_bg_removal_short: 'Hps Latar Blkg',
          array: 'Array',
          auto_fit: 'Pas Otomatis',
          bevel: 'Bevel',
          brightness: 'Kecerahan',
          create_textpath: 'Buat Teks pada Jalur',
          create_textpath_short: 'Teks Jalur',
          crop: 'Potong',
          decompose_path: 'Dekomposisi',
          detach_path: 'Lepaskan Teks pada Jalur',
          detach_path_short: 'Lepaskan',
          disabled_by_gradient: 'Nonaktifkan gradasi sebelum menggunakan fitur ini.',
          disabled_by_infilled: 'Tutup infill sebelum menggunakan fitur ini.',
          disabled_by_infilled_and_variable_text: 'Tutup infill dan teks variabel sebelum menggunakan fitur ini.',
          disabled_by_variable_text: 'Tutup teks variabel sebelum menggunakan fitur ini.',
          disassemble_use: 'Lepaskan',
          disassembling: 'Membongkar...',
          edit_path: 'Edit Lintasan',
          fetching_web_font: 'Mendapatkan font online...',
          grading: 'Pemeringkatan',
          invert: 'Invert',
          offset: 'Offset',
          outline: 'Garis Besar',
          replace_with: 'Ganti Dengan...',
          replace_with_short: 'Ganti',
          sharpen: 'Tajamkan',
          simplify: 'Peredaan',
          smart_nest: 'Sarang Cerdas',
          to_image: 'Ke Gambar',
          to_path: 'Ke Jalur',
          trace: 'Telusuri',
          ungrouping: 'Batalkan pengelompokan...',
          uploading_font_to_machine: 'Mengunggah font ke mesin...',
          wait_for_parsing_font: 'Mengurai font... Mohon tunggu sebentar',
          weld_text: 'Weld Text',
        },
        align: 'Rata',
        boolean: 'Boolean',
        bottom_align: 'Rata Bawah',
        center_align: 'Rata Tengah',
        difference: 'Selisih',
        distribute: 'Sebar',
        flip: 'Balik',
        group: 'Kelompok',
        hdist: 'Sebar Horizontal',
        hflip: 'Balik Horizontal',
        intersect: 'Iris',
        left_align: 'Rata Kiri',
        lock_aspect: 'Kunci Aspek',
        middle_align: 'Rata Tengah',
        option_panel: {
          color: 'Warna',
          current_time: 'Waktu saat ini',
          depth_engraving: 'Emboss',
          fill: 'Isi',
          font_family: 'Font',
          font_size: 'Ukuran',
          font_style: 'Gaya',
          layer_count: 'Jumlah lapisan',
          letter_spacing: 'Spasi Huruf',
          line_spacing: 'Spasi Baris',
          number: 'Nomor urutan',
          offset: 'Offset',
          path_infill: 'Isi Lintasan',
          pwm_engraving: 'Mode Kedalaman',
          pwm_engraving_link: 'https://support.flux3dp.com/hc/en-us/articles/10419884701327',
          recently_used: 'Baru-baru ini digunakan',
          rounded_corner: 'Sudut Bulat',
          shading: 'Gradasi',
          sides: 'Sisi',
          start_offset: 'Offset Teks',
          stroke: 'Garis',
          stroke_color: 'Warna Garis',
          stroke_width: 'Lebar Garis',
          text_align_center: 'Tengah',
          text_align_justify: 'Rata Kanan-Kiri',
          text_align_left: 'Kiri',
          text_align_right: 'Kanan',
          text_content_placeholder: 'Masukkan teks',
          text_infill: 'Isi Teks',
          threshold: 'Ambang Kecerahan',
          threshold_short: 'Ambang',
          variable_text: 'Teks variabel',
          variable_text_link: 'https://support.flux3dp.com/hc/en-us/articles/12689396604175',
          vertical_align: 'Perataan',
          vertical_text: 'Teks Vertikal',
        },
        path_edit_panel: {
          connect: 'Sambungkan',
          delete: 'Hapus',
          disconnect: 'Putuskan',
          node_type: 'JENIS NODE',
          round: 'Bulat',
          sharp: 'Tajam',
        },
        right_align: 'Rata Kanan',
        subtract: 'Kurang',
        top_align: 'Rata Atas',
        ungroup: 'Pisah Kelompok',
        union: 'Gabung',
        unlock_aspect: 'Buka Kunci Aspek',
        vdist: 'Sebar Vertikal',
        vflip: 'Balik Vertikal',
        zoom: 'Perbesar',
      },
      uv_print_block: {
        title: 'Cetak UV',
      },
    },
    svg_editor: {
      unable_to_fetch_clipboard_img: 'Gagal mengambil gambar dari clipboard Anda',
      unnsupported_file_type: 'Jenis file tidak didukung secara langsung. Silakan konversi file menjadi SVG atau bitmap',
    },
    tag: {
      g: 'Grup',
      image: 'Gambar',
      text: 'Teks',
      use: 'Impor SVG',
    },
    tool_panels: {
      _nest: {
        end: 'Tutup',
        no_element: 'Tidak ada elemen untuk diatur.',
        rotations: 'Kemungkinan Rotasi',
        spacing: 'Spasi',
        start_nest: 'Atur',
        stop_nest: 'Berhenti',
      },
      _offset: {
        corner_type: 'Sudut',
        direction: 'Arah Offset',
        dist: 'Jarak Offset',
        expand: 'Perluas',
        fail_message: 'Gagal Meng-offset Objek',
        inward: 'Ke Dalam',
        not_support_message: 'Elemen terpilih mengandung tag SVG yang tidak didukung:\nGambar, Grup, Teks dan Objek Terimpor.',
        outward: 'Ke Luar',
        round: 'Bulat',
        sharp: 'Tajam',
        shrink: 'Perkecil',
      },
      array_dimension: 'Dimensi Pola',
      array_interval: 'Interval Array',
      cancel: 'Batal',
      columns: 'Kolom',
      confirm: 'Konfirmasi',
      dx: 'X',
      dy: 'Y',
      grid_array: 'Buat Pola Grid',
      nest: 'Pengaturan Susunan',
      offset: 'Offset',
      rows: 'Baris',
    },
    units: {
      mm: 'mm',
      walt: 'W',
    },
    zoom_block: {
      fit_to_window: 'Sesuaikan dengan Jendela',
    },
  },
  boxgen: {
    add_option: 'Tambah Opsi',
    basic_box: 'Kotak Dasar',
    beam_radius: 'Kompensasi kerf',
    beam_radius_warning: 'Hapus kompensasi kerf saat tepi atau sambungan kotak pendek untuk memastikan perakitan kotak yang tepat',
    cancel: 'Batal',
    coming_soon: 'Segera Hadir',
    continue_import: 'Lanjutkan untuk Impor',
    control_tooltip: 'Klik kiri untuk memutar\nGulir untuk memperbesar\nKlik kanan untuk menggeser',
    control_tooltip_touch: 'Seret untuk memutar\nCubit untuk memperbesar\nDua jari untuk menggeser',
    cover: 'Tutup',
    customize: 'Sesuaikan',
    depth: 'Kedalaman',
    edge: 'Tepi',
    finger: 'Jari',
    finger_warning: 'Panjang sisi dalam kotak minimal 6mm (0,24 inci) agar kompatibel dengan sambungan jari.',
    import: 'Impor',
    inner: 'Dalam',
    joints: 'Sambungan',
    max_dimension_tooltip: 'Maks lebar adalah %s, maks tinggi/kedalaman pengaturan adalah %s.',
    merge: 'Gabung',
    outer: 'Luar',
    reset: 'Setel Ulang',
    tCount: 'Hitungan T',
    tCount_tooltip: 'Jumlah slot T berlaku untuk sisi pendek; jumlah pada sisi panjang dihitung berdasarkan panjangnya.',
    tDiameter: 'Diameter T',
    text_label: 'Label',
    thickness: 'Ketebalan',
    title: 'BOXGEN',
    tLength: 'Panjang T',
    tSlot: 'Slot-T',
    tSlot_warning: 'Panjang sisi kotak minimal 30mm (1,18 inci) agar kompatibel dengan sambungan T-slot.',
    volume: 'Volume',
    workarea: 'Area Kerja',
    zoom: 'Perbesar',
  },
  buttons: {
    back: 'Kembali',
    back_to_beam_studio: 'Kembali ke Beam Studio',
    done: 'Selesai',
    next: 'Berikutnya',
  },
  calibration: {
    ador_autofocus_focusing_block: 'Tekan ikon "AF" di halaman utama mesin selama 3 detik dan biarkan probe menyentuh Blok Fokus.',
    ador_autofocus_material: 'Tekan ikon “AF” di halaman utama mesin selama 3 detik dan biarkan probe menyentuh bahan dengan lembut.',
    align_4_0: 'Kiri atas',
    align_4_1: 'Kanan atas',
    align_4_2: 'Kiri bawah',
    align_4_3: 'Kanan bawah',
    align_8_0: 'Luar kiri atas',
    align_8_1: 'Luar kanan atas',
    align_8_2: 'Luar kiri bawah',
    align_8_3: 'Luar kanan bawah',
    align_8_4: 'Dalam kiri atas',
    align_8_5: 'Dalam kanan atas',
    align_8_6: 'Dalam kiri bawah',
    align_8_7: 'Dalam kanan bawah',
    align_bottom_left: 'Kiri bawah',
    align_bottom_right: 'Kanan bawah',
    align_red_cross_cut: 'Harap sejajarkan tengah salib merah dengan salib pemotongan.',
    align_red_cross_print: 'Harap sejajarkan tengah salib merah dengan salib cetak.',
    align_top_left: 'Kiri atas',
    align_top_right: 'Kanan atas',
    analyze_result_fail: 'Gagal menganalisis gambar yang ditangkap.<br/>Pastikan:<br/>1. Gambar yang ditangkap sepenuhnya tertutup kertas putih.<br/>2. Platform difokuskan dengan benar.',
    ask_for_skip_engraving_task: 'Apakah Anda ingin melewati langkah pengukiran dan kemudian mengambil foto dan mengkalibrasi secara langsung?',
    ask_for_skip_printing_task: 'Apakah Anda ingin melewati langkah pencetakan dan kemudian mengambil foto dan mengkalibrasi secara langsung?',
    at_focus_height: 'pada ketinggian fokus',
    at_lower_height: 'pada ketinggian lebih rendah',
    back: 'Kembali',
    beamo2_autofocus_material: 'Pindahkan kepala laser secara manual di atas bahan, lalu turunkan probe fokus untuk mengaktifkan fokus otomatis.',
    calculating_camera_matrix: 'Menghitung Matriks Kamera...',
    calculating_regression_parameters: 'Menghitung Parameter Regresi...',
    calibrate_camera_before_calibrate_modules: 'Harap lakukan kalibrasi kamera sebelum mengkalibrasi modul.',
    calibrate_done: 'Kalibrasi selesai. Akurasi kamera yang lebih baik diberikan saat fokus tepat.',
    calibrate_done_diode: 'Kalibrasi selesai. Offset modul laser diode telah disimpan.',
    calibrate_success_msg: 'Kalibrasi berhasil.<br/>Skor kalibrasi adalah %s (%.2f).',
    calibrating: 'Mengkalibrasi...',
    calibrating_with_device_pictures: 'Melakukan kalibrasi dengan gambar perangkat...',
    camera_calibration: 'Kalibrasi Kamera',
    camera_parameter_saved_successfully: 'Parameter kamera berhasil disimpan.',
    cancel: 'Batalkan',
    charuco_auto_focus: 'Gerakkan kepala laser di atas pola lalu tekan <b>AF</b> untuk fokus otomatis.',
    charuco_capture: 'Klik “Berikutnya” untuk menangkap pola',
    charuco_move_to_point_a: 'Gerakkan kepala laser untuk menyelaraskan cahaya merah dengan pusat <b>titik A</b>.',
    charuco_move_to_point_b: 'Gerakkan kepala laser secara horizontal untuk menyelaraskan cahaya merah dengan pusat <b>titik B</b>.',
    charuco_place_charuco_horizontal: 'Tempatkan pola kalibrasi secara horizontal di <b>%s</b> area kerja.',
    charuco_place_charuco_vertical: 'Tempatkan pola kalibrasi secara vertikal di <b>%s</b> area kerja.',
    charuco_position_bottom_left: 'Kiri Bawah',
    charuco_position_bottom_right: 'Kanan Bawah',
    charuco_position_center: 'Tengah',
    charuco_position_left: 'Kiri',
    charuco_position_right: 'Kanan',
    charuco_position_top_left: 'Kiri Atas',
    charuco_position_top_right: 'Kanan Atas',
    check_checkpoint_data: 'Data titik kontrol',
    check_device_pictures: 'Periksa Gambar Perangkat',
    check_pnp_desc: 'Pastikan penanda merah sejajar dengan titik pengukiran\nJika tidak, klik "Kembali" untuk menyesuaikan.\nJika semuanya sudah baik, kerja bagus! 🎉',
    checking_checkpoint: 'Memeriksa data titik kontrol...',
    checking_pictures: 'Memeriksa gambar perangkat...',
    click_next: 'Klik "Berikutnya"',
    click_next_to_take_picture: 'Klik "Berikutnya" untuk mengambil foto.',
    diode_calibration: 'Kalibrasi Modul Laser Diode',
    do_engraving: 'Lakukan Pengukiran',
    download_and_print_calibration_pattern: 'Silakan unduh file pola kalibrasi di bawah ini dan cetak di kertas ukuran A4 (atau Letter).',
    download_calibration_pattern: 'Unduh Pola Kalibrasi',
    download_chessboard_file: 'Unduh file papan catur',
    downloading_checkpoint: 'Mengunduh data titik kontrol...',
    downloading_pictures: 'Mengunduh Gambar...',
    drawing_calibration_image: 'Menggambar gambar kalibrasi...',
    dx: 'X',
    dy: 'Y',
    elevate_and_cut: 'Menaikkan dan Memotong',
    elevate_and_cut_step_1: 'Letakkan sepotong kayu berukuran A4 berwarna terang di tengah area kerja, diangkat ke 20mm.',
    elevate_and_cut_step_1_prism_lift: 'Gunakan Ador Prism Lift dengan panjang maksimum 14 mm bersama dengan kayu setidaknya 6 mm tebal.',
    failed_to_calibrate_camera: '#848 Gagal mengkalibrasi kamera, silakan hubungi Layanan FLUX.',
    failed_to_calibrate_chessboard: 'Gagal mengkalibrasi dengan gambar papan catur.',
    failed_to_calibrate_with_pictures: '#848 Gagal melakukan kalibrasi dengan gambar perangkat.',
    failed_to_detect_calibration_pattern: 'Gagal mendeteksi pola kalibrasi. Silakan atur pencahayaan kamera atau posisikan ulang pola kalibrasi dan coba lagi.',
    failed_to_download_pictures: '#848 Gagal mengunduh gambar, silakan hubungi Dukungan FLUX.',
    failed_to_move_laser_head: 'Gagal memindahkan kepala laser.',
    failed_to_parse_checkpoint: 'Gagal mengurai data titik kontrol.',
    failed_to_save_calibration_results: '#849 Gagal menyimpan hasil kalibrasi, silakan coba lagi. Jika ini terus terjadi, silakan hubungi Layanan FLUX.',
    failed_to_save_camera_parameter: 'Gagal menyimpan parameter kamera.',
    failed_to_solve_pnp: 'Gagal memecahkan posisi kamera.',
    finish: 'Selesai',
    found_checkpoint: 'Data titik kontrol ditemukan di perangkat Anda. Apakah Anda ingin memulihkannya dari titik kontrol?',
    getting_plane_height: 'Mendapatkan Tinggi Bidang...',
    hint_adjust_parameters: 'Gunakan parameter ini untuk menyesuaikan kotak merah',
    hint_red_square: 'Harap sejajarkan bagian luar kotak merah dengan kotak pemotongan.',
    material_4_a4_paper: 'Empat lembar kertas putih ukuran A4 (atau Letter).',
    material_a4_calibration_pattern: 'Pola kalibrasi ukuran A4 (atau Letter).',
    materials_required: 'Bahan yang dibutuhkan:',
    module_calibration_2w_ir: 'Kalibrasi Modul Inframerah',
    module_calibration_printer: 'Kalibrasi Modul Printer',
    module_offset_settings: 'Pengaturan Offset',
    module_offset_settings_desc: 'Silakan sesuaikan nilai offset X dan Y untuk menyelaraskan posisi %s yang sebenarnya dengan keluaran Laser CO2.',
    module_offset_settings_save_failed: 'Gagal menyimpan pengaturan offset.',
    moving_laser_head: 'Memindahkan kepala laser...',
    moving_platform: 'Memindahkan platform...',
    next: 'Berikutnya',
    no_picture_found: '#852 Perangkat Anda tidak memiliki foto mentah yang tersedia untuk kalibrasi. Silakan lakukan "Kalibrasi Kamera (Lanjutan)".',
    perform_autofocus_bb2: 'Silakan pergi ke panel kontrol mesin dan tekan AF untuk melakukan fokus otomatis.',
    perform_autofocus_bm2: 'Pindahkan kepala laser secara manual di atas bahan, lalu turunkan probe fokus untuk memicu fokus otomatis.',
    please_do_camera_calibration_and_focus: {
      beambox: 'Saat mengkalibrasi modul laser diode, kamera diperlukan.\nPastikan kamera mesin ini telah dikalibrasi.\nDan sesuaikan platform ke titik fokus (tinggi akrilik yang dibalik)',
      beamo: 'Saat mengkalibrasi modul laser diode, kamera diperlukan.\nPastikan kamera mesin ini telah dikalibrasi.\nDan sesuaikan kepala laser untuk fokus pada objek ukiran (tinggi akrilik yang dibalik)',
    },
    please_goto_editor_first: 'Harap selesaikan pengaturan sebelum melanjutkan',
    please_place_dark_colored_paper: 'Silakan letakkan kertas berwarna gelap ukuran A4 atau Letter di tengah area kerja.',
    please_place_paper: 'Silakan letakkan kertas putih ukuran A4 atau Letter di pojok kiri atas area kerja.',
    please_place_paper_center: 'Silakan letakkan kertas putih ukuran A4 atau Letter di tengah area kerja.',
    please_refocus: {
      beambox: 'Silakan sesuaikan platform ke titik fokus (tinggi akrilik yang dibalik)',
      beamo: 'Silakan sesuaikan kepala laser untuk memfokuskan pada benda ukiran (tinggi akrilik yang dibalik)',
      beamo_af: 'Silakan ketuk dua kali tombol di samping penambahan fokus otomatis dan biarkan probe menyentuh material dengan lembut.',
      hexa: 'Klik dua kali tombol penyesuaian tinggi untuk menaikkan meja sarang lebah dan membuat probe menyentuh bahan benda ukiran.',
    },
    preparing_to_take_picture: 'Persiapan untuk mengambil foto...',
    promark_help_link: 'https://support.flux3dp.com/hc/en-us/articles/11173605809295',
    put_charuco: 'Tempatkan Pola Kalibrasi',
    put_charuco_1: 'Cetak pola kalibrasi (A4/Letter).',
    put_charuco_2: 'Tempelkan rata pada papan yang kaku.',
    put_charuco_3: 'Letakkan di tengah dan lakukan fokus otomatis.',
    put_charuco_bm2_1: 'Cetak file pola kalibrasi pada kertas A4 (ukuran Letter) untuk kalibrasi.',
    put_charuco_bm2_2: 'Klik “Berikutnya” dan ikuti panduan untuk menempatkan kertas.',
    put_charuco_promark_2: "Pastikan kertas kalibrasi terlihat jelas tanpa silau. Klik 'Berikutnya' untuk mengambil foto.",
    put_charuco_promark_desc_1: 'Gunakan kertas kalibrasi yang disediakan dalam kotak aksesori, atau cetak pola kalibrasi berikut di kertas A4 untuk kalibrasi kamera.',
    put_charuco_promark_desc_2: 'Letakkan kertas kalibrasi secara datar dan di tengah pada platform kerja.',
    put_chessboard_promark_1: 'Sesuaikan jarak fokus ke fokus yang sesuai untuk lensa bidang.',
    put_chessboard_promark_2: 'Pastikan kertas papan catur terlihat jelas tanpa silau. Klik "Berikutnya" untuk mengambil foto.',
    put_chessboard_promark_desc_1: 'Silakan gunakan kertas papan catur yang disediakan di kotak aksesori, atau cetak pola papan catur berikut di kertas A4 untuk kalibrasi kamera.',
    put_chessboard_promark_desc_2: 'Harap letakkan kertas papan catur secara datar dan terpusat di platform kerja.',
    put_paper: 'Letakkan kertas',
    put_paper_bm2_1: 'Letakkan dua kertas A4 putih secara datar dan amankan.',
    put_paper_bm2_2: 'Turunkan probe fokus untuk fokus otomatis pada kertas.',
    put_paper_bm2_3: 'Tutup penutup pintu.',
    put_paper_bm2_4: 'Klik "Mulai Ukir".',
    put_paper_promark: 'Letakkan Karton Hitam',
    put_paper_promark_1: 'Letakkan karton hitam dari kotak aksesori di platform kerja.',
    put_paper_promark_2: 'Sesuaikan fokus dengan benar, lalu klik "Mulai Ukir" untuk melanjutkan.',
    put_paper_skip: 'Jika gambar kalibrasi tidak otomatis melanjutkan ke pengambilan gambar, tekan "Lewati" untuk mengambil gambar.',
    put_paper_step1: 'Harap letakkan selembar kertas putih berukuran A4 atau Surat di tengah area kerja.',
    put_paper_step2: 'Pastikan empat sudut kertas terpasang dengan baik untuk memastikan kertas tersebut datar.',
    put_paper_step3: 'Klik "Mulai Ukir".',
    put_paper_wide_angle_1: 'Letakkan empat kertas putih ukuran A4 atau Letter secara rata untuk menutupi seluruh area kerja.',
    put_paper_wide_angle_2: 'Amankan kertas agar tetap rata.',
    relocate_camera: 'Pindahkan Kamera',
    relocate_camera_desc: 'Jika pintu dibuka atau kepala laser dipindahkan, pindahkan kamera dan sejajarkan kembali titik-titiknya.',
    res_average: 'Rata-rata',
    res_excellent: 'Luar biasa',
    res_poor: 'Buruk',
    reset_points: 'Atur ulang titik',
    retake: 'Ambil Ulang Gambar',
    rotation_angle: 'Rotasi',
    show_last_config: 'Tampilkan Hasil Terakhir',
    skip: 'Lewati',
    solve_pnp_bm2: 'Konfirmasi bahwa 16 tanda terukir pada kertas. (Jika tidak, klik Kembali untuk mengukir lagi.)',
    solve_pnp_keep_door_closed: 'Tetap tutup pintu selama proses berikut.',
    solve_pnp_move_platform: 'Mesin akan secara otomatis bergerak ke bawah dan mengambil foto lain. Mohon jangan memindahkan kertas kalibrasi selama proses ini.',
    solve_pnp_open_the_lid: 'Silakan buka penutup untuk mengambil foto.',
    solve_pnp_step1: 'Silakan sejajarkan titik ukiran sesuai dengan nomor dan posisi yang diharapkan dari setiap titik penanda merah.',
    solve_pnp_step2: 'Anda dapat menekan "Ambil Ulang Gambar" untuk meluruskan kembali atau menyesuaikan posisi penanda secara manual.',
    solve_pnp_step3: 'Jika titik pengukiran terlihat meleset, seret tampilan hingga titik tersebut terlihat, lalu klik "Ambil Ulang Gambar".',
    solve_pnp_title: 'Luruskan Titik Penanda',
    start_engrave: 'Mulai Ukir',
    start_printing: 'Mulai Cetak',
    step: 'Langkah',
    taking_picture: 'Mengambil Gambar...',
    title_align_marker_points: 'Sejajarkan Titik Penanda',
    title_capture_calibration_pattern: 'Tangkap Pola Kalibrasi',
    title_confirm_calibration_result: 'Konfirmasi Hasil Kalibrasi',
    title_engrave_marker_points: 'Ukir Titik Penanda',
    title_prepare_materials: 'Siapkan bahan',
    unable_to_load_camera_parameters: "#851 Tidak ada parameter kalibrasi kamera yang tersedia di perangkat Anda. Pergi ke 'Kalibrasi' > 'Kalibrasi Kamera (Lanjutan)' untuk menyelesaikan kalibrasi dan mendapatkan parameter.",
    update_firmware_msg1: 'Firmware Anda tidak mendukung fungsi ini. Harap perbarui firmware ke v',
    update_firmware_msg2: 'atau di atas untuk melanjutkan。 (Menu > Mesin > [Mesin Anda] > Perbarui Firmware)',
    uploading_images: 'Mengunggah Gambar...',
    use_last_config: 'Gunakan Nilai Kalibrasi Terakhir',
    use_old_camera_parameter: 'Apakah Anda ingin menggunakan parameter lensa kamera saat ini?',
    with_af: 'Dengan Fokus Otomatis',
    with_prism_lift: 'Dengan Ador Prism Lift',
    with_promark_safe_plus: 'Dengan Promark Safe+',
    without_af: 'Tanpa Fokus Otomatis',
    without_prism_lift: 'Tanpa Ador Prism Lift',
    without_promark_safe_plus: 'Tanpa Promark Safe+',
    x_ratio: 'Rasio X',
    y_ratio: 'Rasio Y',
    zendesk_link: 'https://support.flux3dp.com/hc/en-us/articles/360001811416',
  },
  camera_data_backup: {
    download_success: 'Data kamera berhasil diunduh.',
    downloading_data: 'Mengunduh data...',
    estimated_time_left: 'Estimasi waktu tersisa:',
    folder_not_exists: 'Folder yang dipilih tidak ada.',
    incorrect_folder: 'Gagal mengunggah data kalibrasi. Harap periksa apakah folder yang Anda pilih sudah benar.',
    no_picture_found: 'Tidak ada gambar ditemukan di mesin.',
    title: 'Cadangkan Data Kamera',
    upload_success: 'Data kamera berhasil diunggah.',
    uploading_data: 'Mengunggah data...',
  },
  canvas_control: {
    calculate: 'Perkirakan waktu',
    canvas_zoom: 'Zoom',
    exposure: 'Eksposur',
    not_supported: 'Tidak Didukung',
    opacity: 'Opasitas',
  },
  caption: {
    connectionTimeout: 'Koneksi timeout',
  },
  change_logs: {
    added: 'Ditambahkan:',
    change_log: 'Log Perubahan:',
    changed: 'Diubah:',
    fixed: 'Diperbaiki:',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/sections/360000421876',
    see_older_version: 'Lihat Versi Lama',
  },
  cloud_sync: {
    import_config: 'Pengaturan cloud ditemukan untuk perangkat ini. Apakah Anda ingin mengimpornya?',
    import_failed: 'Gagal membaca pengaturan cloud.',
    sync_config: 'Apakah Anda ingin menyinkronkan pengaturan ini ke cloud?',
    sync_failed: 'Gagal menyinkronkan pengaturan ke cloud.',
    sync_success: 'Pengaturan berhasil disinkronkan ke cloud.',
  },
  code_generator: {
    barcode: 'Kode Batang',
    content: 'Konten',
    import: 'Impor',
    qr_code: 'Kode QR',
    type: 'Jenis',
  },
  connection_issue_guide: {
    alert_link: 'Terputus? Coba cara pemecahan masalah ini.',
    connect_computer: {
      content: 'Komputer Anda harus berada di jaringan yang sama dengan mesin.',
      macos_steps: 'Klik ikon Wi-Fi di bilah menu. Lalu pilih hotspot ponsel Anda.',
      macos_title: 'macOS',
      title: 'Hubungkan Komputer Anda',
      windows_steps: 'Klik ikon jaringan di bilah tugas. Lalu pilih hotspot ponsel Anda.',
      windows_title: 'Windows',
    },
    connect_wifi: {
      cant_find_hotspot: 'Mesin tidak dapat menemukan hotspot saya',
      dont_know_hotspot_name: 'Saya tidak tahu nama hotspot saya',
      step1: '1. Pada panel sentuh mesin, buka: Jaringan → Hubungkan ke Wi-Fi.',
      step2: '2. Temukan dan pilih nama hotspot ponsel Anda dari daftar Wi-Fi.',
      step3: '3. Masukkan kata sandi hotspot dan hubungkan.',
      title: 'Hubungkan Mesin ke Hotspot Ponsel',
    },
    enter_ip: {
      check_firmware: 'Versi firmware',
      check_ip_reachable: 'IP dapat dijangkau',
      check_machine_responds: 'Mesin merespons',
      placeholder: 'Alamat IP',
      step1: 'Masukkan alamat IP yang Anda temukan pada langkah sebelumnya.',
      step2: 'Klik "Verifikasi" untuk menguji koneksi.',
      step3: 'Beam Studio akan memeriksa:',
      title: 'Masukkan Alamat IP Mesin Anda',
      verify: 'Verifikasi',
    },
    fail: {
      bullet1: '• Model mesin dan nomor seri Anda',
      bullet2: '• Alamat IP yang ditampilkan pada panel sentuh',
      bullet3: '• Deskripsi kesalahan yang Anda alami',
      contact_title: 'Saat menghubungi dukungan, ada baiknya menyiapkan:',
      intro: 'Jangan khawatir — ini tidak selalu berarti ada masalah dengan mesin Anda. Mungkin ada faktor lain yang memengaruhi koneksi. Tim dukungan kami siap membantu Anda menemukan penyebabnya.',
      title: 'Kami Tidak Dapat Menyelesaikan Pengujian',
    },
    hotspot: {
      android_steps: 'Pengaturan → Koneksi → Hotspot Seluler dan Penambatan → Hotspot Seluler',
      android_title: 'Android',
      ios_steps: 'Pengaturan → Hotspot Pribadi → Izinkan Orang Lain Bergabung',
      ios_title: 'iPhone (iOS)',
      tip: 'Tips: Gunakan nama hotspot bahasa Inggris yang sederhana dan kata sandi berupa angka (mis. Nama: FLUX_Test   Kata Sandi: 12345678)',
      warning_2_4ghz: 'Penting: Mesin FLUX hanya mendukung Wi-Fi 2.4GHz. Atur hotspot Anda ke 2.4GHz sebelum melanjutkan.',
    },
    how_it_works: 'Cara kerja pengujian:',
    how_it_works_step1: '1. Atur ponsel Anda sebagai hotspot Wi-Fi.',
    how_it_works_step2: '2. Hubungkan mesin ke hotspot.',
    how_it_works_step3: '3. Hubungkan komputer Anda ke hotspot yang sama.',
    how_it_works_step4: '4. Uji koneksi di Beam Studio.',
    intro: 'Mari jalankan pengujian cepat untuk memeriksa apakah mesin Anda berfungsi dengan baik. Kami akan menghubungkan mesin dan komputer Anda melalui hotspot ponsel Anda untuk menentukan apakah masalahnya ada pada jaringan Anda atau pada mesin itu sendiri.',
    ip_address: {
      step1: 'Pada panel sentuh mesin, buka:\nJaringan → Cari "Alamat IP"',
      step2: 'IP biasanya terlihat seperti: 172.20.10.x atau 192.168.x.x\n(Ini tergantung pada hotspot ponsel Anda)',
      step3: 'Catat alamat IP ini untuk langkah berikutnya.',
      title: 'Temukan Alamat IP Mesin Anda',
      warning: 'Jika IP dimulai dengan 169.254, koneksi gagal. Kembali ke Langkah 1 dan coba lagi.',
    },
    success: {
      cause: 'Masalah koneksi yang Anda alami kemungkinan besar disebabkan oleh lingkungan jaringan lokal Anda, bukan mesin itu sendiri.',
      intro: 'Anda telah berhasil menyelesaikan pengujian koneksi Wi-Fi — kerja bagus! Ini mengonfirmasi bahwa mesin FLUX Anda berfungsi dengan sempurna.',
      recommend1: '• Hubungi Penyedia Layanan Internet (ISP) atau produsen router Anda untuk bantuan terkait pengaturan Wi-Fi',
      recommend2: '• Tanyakan kepada administrator jaringan jika Anda berada di sekolah, kantor, atau ruang kerja bersama',
      recommend3: '• Periksa apakah router Anda mendukung 2.4GHz dan coba mulai ulang',
      recommend_title: 'Yang Kami Rekomendasikan:',
      title: 'Kerja Bagus! 🎉',
    },
    title: 'Masalah Koneksi?',
  },
  curve_engraving: {
    '921': 'Gagal melakukan fokus otomatis.',
    '922': 'Gagal melakukan pengukuran dengan cahaya merah.',
    amount: 'Jumlah',
    apply_arkwork: 'Terapkan karya seni pada kurva',
    apply_camera: 'Terapkan gambar kamera pada kurva',
    click_to_select_point: 'Klik untuk memilih atau membatalkan pilihan titik untuk mengukur ulang.',
    coloumns: 'Kolom',
    column_gap: 'Celah Kolom',
    err_object_over_range: 'Objek melebihi jangkauan pengukuran.',
    failed_to_take_reference: 'Gagal mengambil referensi',
    gap: 'Celah',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
    measure_audofocus_area: 'Ukur Area Autofokus',
    preview_3d_curve: 'Pratinjau Ukiran Kurva',
    remeasure: 'Ukur ulang',
    remeasuring_points: 'Mengukur ulang titik...',
    reselect_area: 'Pilih Area Kembali',
    row_gap: 'Celah Baris',
    rows: 'Baris',
    set_object_height: 'Atur Tinggi Objek',
    set_object_height_desc: 'Ukur ketebalan maksimum objek.',
    start_autofocus: 'Mulai Autofokus',
    starting_measurement: 'Memulai pengukuran...',
    sure_to_delete: 'Apakah Anda ingin menghapus data fokus ukiran kurva?',
    take_reference: 'Ambil Referensi',
    take_reference_desc: 'Silakan pindahkan kepala laser ke titik tertinggi objek, turunkan probe fokus, dan klik "Konfirmasi" untuk memfokuskan.',
  },
  device: {
    abort: 'Batalkan',
    aborted: 'Dibatalkan',
    aborting: 'Membatalkan',
    busy: 'Sibuk',
    cartridge_info_read_failed: 'Please ensure that the ink is fully inserted. Try to remove the ink and install it back.',
    cartridge_info_verification_failed: 'Please verify that your ink is FLUX authentic.',
    cartridge_serial_number: 'Ink cartridge serial number',
    close_door_to_read_cartridge_info: "To access ink information, please close the machine's door cover.",
    completed: 'Selesai',
    completing: 'Menyelesaikan',
    deviceList: 'Daftar Mesin',
    disable: 'Nonaktifkan',
    disconnectedError: {
      caption: 'Mesin terputus',
      message: 'Harap konfirmasi apakah akses jaringan %s tersedia',
    },
    firmware_version: 'Versi Firmware',
    ink_color: 'Ink color',
    ink_level: 'Ink level',
    ink_type: 'Ink type',
    IP: 'IP',
    model_name: 'Nama Model',
    occupied: 'Menduduki',
    pause: 'Jeda',
    paused: 'Dijeda',
    pausedFromError: 'Dihentikan karena kesalahan',
    pausing: 'Menjeda',
    please_wait: 'Mohon Tunggu...',
    preparing: 'Mempersiapkan',
    processing: 'Memproses',
    quit: 'Keluar',
    ready: 'Siap',
    reconnecting: 'Menyambungkan kembali',
    reset: 'Reset',
    resuming: 'Melanjutkan',
    retry: 'Coba lagi',
    running: 'Bekerja',
    scanning: 'Memindai',
    select: 'Pilih',
    select_printer: 'Pilih Printer',
    serial_number: 'Nomor Seri',
    start: 'Mulai',
    starting: 'Memulai',
    status: 'Status',
    submodule_type: 'Module',
    toolhead_change: 'Ganti kepala alat',
    unknown: 'Tidak diketahui',
    uploading: 'Mengunggah',
    UUID: 'UUID',
  },
  device_selection: {
    go_to_settings: 'Masuk Ke Pengaturan',
    macos_15_local_network_permission: 'Di macOS 15 atau yang lebih baru, aktifkan akses Beam Studio ke jaringan lokal di Pengaturan Sistem > Privasi & Keamanan > Jaringan Lokal.',
    no_device: '#801 Kami tidak dapat menemukan mesin Anda di jaringan.\nHarap ikuti <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">panduan</a> untuk mengatasi masalah koneksi.',
    no_device_web: "#801 Periksa status mesin Anda, atau klik 'Setup Mesin' di bawah untuk mengatur mesin.",
    select_usb_device: 'Pilih Perangkat USB',
  },
  editor: {
    exposure: 'Kecerahan',
    nozzle_refresh_area: 'Area Penyegaran Nozel',
    opacity: 'Opasitas Pratinjau',
    prespray_area: 'Area Priming',
  },
  error_pages: {
    screen_size: 'Harap dicatat bahwa Beam Studio mungkin tidak berfungsi secara optimal pada perangkat Anda. Untuk pengalaman terbaik, disarankan perangkat dengan lebar layar minimal 1024 piksel.',
  },
  flux_id_login: {
    connection_fail: '#847 Gagal terhubung ke layanan keanggotaan FLUX.',
    email: 'Email',
    flux_plus: {
      access_monotype_feature: 'Anda tidak berlangganan Add-on Font Monotype.',
      access_monotype_feature_note: 'Anda perlu berlangganan FLUX+ Pro atau Add-on Font Monotype untuk mengakses fitur ini.',
      access_plus_feature_1: 'Anda mengakses fitur',
      access_plus_feature_2: 'fitur.',
      access_plus_feature_note: 'Anda perlu berlangganan FLUX+ untuk mengakses fitur ini.',
      ai_credit_tooltip: 'Untuk fitur AI',
      explore_plans: 'Jelajahi Rencana FLUX+',
      features: {
        ai_bg_removal: 'Pembuangan Latar Belakang AI',
        boxgen: 'Generator Kotak 3D',
        dmkt: '1000+ File Desain',
        monotype: '250+ Font Premium',
        my_cloud: 'Penyimpanan Cloud Tak Terbatas',
      },
      flux_credit_tooltip: 'Untuk file Pasar Desain dan penghapusan latar belakang AI',
      get_addon: 'Dapatkan Add-on',
      goto_member_center: 'Pergi ke Pusat Anggota',
      learn_more: 'Pelajari Lebih Lanjut',
      member_center_url: 'https://member.flux3dp.com/en-US/subscription',
      subscribe_now: 'Berlangganan sekarang',
      thank_you: 'Terima kasih telah menjadi anggota berharga!',
      website_url: 'https://flux3dp.com/subscription',
    },
    forget_password: 'Lupa Kata Sandi?',
    incorrect: 'Alamat email atau kata sandi salah.',
    login: 'Masuk',
    login_success: 'Sudah masuk',
    lost_password_url: 'https://id.flux3dp.com/user/forgot-password',
    new_to_flux: 'Baru di FLUX? Buat akun.',
    not_verified: 'Alamat email belum diverifikasi.',
    password: 'Kata Sandi',
    register: 'Buat Akun FLUX Anda',
    remember_me: 'Ingat saya',
    sign_in_later: 'Masuk nanti',
    signup_url: 'https://id.flux3dp.com/user/login#up',
    unlock_shape_library: 'Masuk untuk membuka kunci database bentuk.',
  },
  framing: {
    area_check: 'Pemeriksaan Area',
    areacheck_desc: 'Memastikan area kerja aman dengan menampilkan kotak pembatas objek dan zona akselerasi kepala laser.',
    calculating_task: 'Menghitung tugas...',
    contour: 'Kontur',
    contour_desc: 'Pratinjau garis besar pola sebenarnya.',
    framing: 'Pembingkaian',
    framing_desc: 'Pratinjau kotak pembatas objek.',
    hull: 'Kerangka',
    hull_desc: 'Memperlihatkan bentuk yang mengikuti desain, seperti karet yang melilit objek.',
    low_laser: 'Laser rendah',
    low_laser_desc: 'Tetapkan nilai laser daya rendah untuk tugas pembingkaian.',
    repeat: 'Ulangi',
    rotate_axis: 'Poros rotasi',
    rotateaxis_desc: 'Pratinjau pusat poros rotasi, poros itu sendiri tidak bergerak.',
    rotation_frame_warning: 'Pratinjau bingkai akan berputar sekali. Hindari berhenti di tengah jalan untuk mencegah ketidaksesuaian posisi penandaan.',
    rotation_framing_desc: 'Pratinjau jangkauan rotasi penuh, poros berputar sesuai dengan pratinjau.',
    start_task: 'Mulai Tugas',
    start_task_description: 'Setelah menyelesaikan pratinjau bingkai, klik "Mulai Tugas" untuk mengirimkan pekerjaan.',
  },
  general: {
    choose_folder: 'Pilih Folder',
    processing: 'Memproses...',
  },
  generators: {
    box_generator: 'Generator Kotak',
    code_generator: 'Pembuat Kode',
    keychain_generator: 'Generator Gantungan Kunci',
    material_test_generator: 'Generator Uji Material',
    puzzle_generator: 'Pembuat puzzle',
    title: 'Generator',
  },
  generic_error: {
    OPERATION_ERROR: '[OE] Terjadi konflik status, harap coba ulangi tindakan.',
    SUBSYSTEM_ERROR: '[SE] Terjadi kesalahan saat firmware mesin mengeksekusi tugas. Harap mulai ulang mesin.',
    UNKNOWN_COMMAND: '[UC] Harap perbarui Firmware Perangkat',
    UNKNOWN_ERROR: '[UE] Terjadi kesalahan yang tidak diketahui. Harap mulai ulang Beam Studio dan mesin.',
  },
  global: {
    apply: 'Terapkan',
    back: 'Kembali',
    cancel: 'Batal',
    editing: {
      redo: 'Ulangi',
      reset: 'Atur Ulang',
      reset_view: 'Atur Ulang Tampilan',
      undo: 'Urungkan',
      zoom_in: 'Perbesar',
      zoom_out: 'Perkecil',
    },
    enable: 'Aktifkan',
    height: 'Tinggi',
    mode_conflict: 'Opsi ini tidak tersedia dalam mode saat ini.',
    ok: 'OK',
    preview: 'Pratinjau',
    save: 'Simpan',
    save_and_exit: 'Simpan dan Keluar',
    saving: 'Menyimpan...',
    select: 'Pilih',
    stop: 'Berhenti',
    width: 'Lebar',
  },
  google_font_panel: {
    all_languages: 'Semua bahasa',
    category: 'Kategori',
    language_label: 'Bahasa',
    language_placeholder: 'Bahasa',
    language_unavailable_offline: 'Tidak tersedia offline',
    more_google_fonts: 'Lebih banyak Google Fonts...',
    no_fonts_available: 'Tidak ada font yang tersedia.',
    no_internet_connection: 'Tidak Ada Koneksi Internet',
    no_results_message: 'Tidak ditemukan font yang cocok dengan kriteria pencarian Anda.',
    no_selection: 'Tidak ada font yang dipilih',
    offline_message: 'Google Fonts tidak tersedia offline. Silakan terhubung ke internet untuk menjelajah dan memilih Google Fonts.',
    search_placeholder: 'Cari font...',
    search_unavailable_offline: 'Pencarian tidak tersedia offline',
    selected_prefix: 'Dipilih:',
    title: 'Google Fonts',
    unavailable_message: 'Google Fonts saat ini tidak tersedia. Silakan periksa koneksi internet Anda atau hubungi administrator Anda.',
  },
  image_edit_panel: {
    eraser: {
      brush_size: 'Ukuran Kuas',
      description: 'Klik atau seret untuk menghapus area yang tidak diinginkan secara manual.',
      title: 'Penghapus',
    },
    magic_wand: {
      description: 'Pilih dan hapus area yang berdekatan berdasarkan kesamaan warna.',
      title: 'Tongkat Ajaib',
      tolerance: 'Toleransi',
    },
    rounded_corner: {
      description: 'Sesuaikan kebulatan sudut objek.',
      radius: 'Radius',
      title: 'Sudut Membulat',
    },
    title: 'Edit Gambar',
  },
  initialize: {
    back: 'Kembali',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    connect: 'Sambungkan',
    connect_ethernet: {
      title: 'Sambungan Langsung',
      tutorial1: '1. Sambungkan mesin dengan komputer Anda dengan kabel ethernet.',
      tutorial2_1: '2. Ikuti',
      tutorial2_2: '2. untuk menjadikan komputer Anda sebagai router.',
      tutorial2_a_href_mac: 'https://support.flux3dp.com/hc/en-us/articles/360001517076',
      tutorial2_a_href_win: 'https://support.flux3dp.com/hc/en-us/articles/360001507715',
      tutorial2_a_text: 'panduan ini',
      tutorial3: '3. Klik Lanjutkan.',
    },
    connect_machine_ip: {
      alert: {
        swiftray_connection_error: 'Tidak dapat terhubung ke server. Silakan mulai ulang Beam Studio dan coba lagi.',
      },
      check_camera: 'Memeriksa ketersediaan kamera',
      check_connection: 'Memeriksa Koneksi Mesin',
      check_firmware: 'Memeriksa versi firmware',
      check_ip: 'Memeriksa ketersediaan IP',
      check_swiftray_connection: 'Memeriksa koneksi server',
      check_swiftray_connection_unreachable: 'server tidak dapat dijangkau',
      check_usb: 'Periksa Koneksi USB',
      connection_failed_hint: 'Tidak dapat terhubung ke mesin. Silakan lihat <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">panduan ini</a> untuk memecahkan masalah.',
      enter_ip: 'Masukkan IP Mesin Anda',
      finish_setting: 'Mulai Membuat!',
      invalid_format: 'Format tidak valid',
      invalid_ip: 'IP Tidak Valid: ',
      promark_hint: 'Jika Anda berulang kali gagal terhubung melalui USB, silakan lihat <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/11318820440591">artikel di Pusat Bantuan</a>.',
      retry: 'Coba lagi',
      starts_with_169254: 'Dimulai dengan 169.254',
      succeeded_message: 'Berhasil terhubung 🎉',
      unreachable: 'IP tidak dapat dijangkau',
      unreachable_macos_15: 'Di macOS 15 atau lebih baru, aktifkan akses Beam Studio ke jaringan lokal di Pengaturan Sistem > <a target="_blank" href="x-apple.systempreferences:com.apple.preference.security?Privacy_LocalNetwork">Privasi & Keamanan</a> > Jaringan Lokal.',
    },
    connect_usb: {
      connect_camera: 'Hubungkan kamera mesin ke komputer Anda dengan kabel USB.',
      title: 'Koneksi USB',
      title_sub: '(HEXA & Ador Saja)',
      turn_off_machine: 'Matikan mesin.',
      turn_on_machine: 'Nyalakan mesin.',
      tutorial1: 'Sambungkan mesin dengan komputer Anda dengan kabel USB.',
      tutorial2: "Klik 'Lanjutkan'.",
      wait_for_turning_on: 'Klik "Lanjutkan" setelah proses startup selesai dan Anda telah masuk ke layar utama.',
    },
    connect_wifi: {
      title: 'Menyambung ke Wi-Fi',
      tutorial1: '1. Pergi ke Panel Sentuh > Klik "MESIN" > Klik "Jaringan" > "Sambung ke WiFi".',
      tutorial1_ador: '1. Pergi ke Panel Sentuh > Klik "MESIN" > Klik "Jaringan" > "Sambung ke WiFi".',
      tutorial2: '2. Pilih dan sambung Wi-Fi pilihan Anda.',
      what_if_1: 'Bagaimana jika saya tidak melihat Wi-Fi saya?',
      what_if_1_content: '1. Mode enkripsi Wi-Fi harus WPA2 atau tanpa kata sandi.\n2. Mode enkripsi dapat diatur di antarmuka administrasi router Wi-Fi. Jika router tidak mendukung WPA2 dan Anda membutuhkan bantuan memilih router yang tepat, silakan hubungi Dukungan FLUX.\n3. Saluran Wi-Fi harus 2,4Ghz (5Ghz tidak didukung).',
      what_if_2: 'Bagaimana jika saya tidak melihat Wi-Fi sama sekali?',
      what_if_2_content: '1. Pastikan stik Wi-Fi terpasang dengan benar.\n2. Jika tidak ada Alamat MAC jaringan nirkabel di layar sentuh, silakan hubungi Dukungan FLUX.',
    },
    connect_wired: {
      title: 'Menyambung ke Jaringan Kabel',
      tutorial1: '1. Sambungkan mesin dengan router Anda.',
      tutorial2: '2. Tekan "MESIN" > "Jaringan" untuk mendapatkan IP jaringan kabel.',
      tutorial2_ador: '2. Tekan "MESIN" > "Jaringan" untuk mendapatkan IP jaringan kabel.',
      what_if_1: 'Bagaimana jika IP kosong?',
      what_if_1_content: '1. Pastikan kabel Ethernet terpasang dengan benar.\n2. Jika tidak ada Alamat MAC jaringan kabel di layar sentuh, silakan hubungi Dukungan FLUX.',
      what_if_2: 'Bagaimana jika IP dimulai dengan 169?',
      what_if_2_content: '1. Jika alamat IP dimulai dengan 169.254, itu harus masalah pengaturan DHCP, silakan hubungi ISP (penyedia layanan internet) Anda untuk bantuan lebih lanjut.\n2. Jika komputer Anda terhubung ke internet langsung menggunakan PPPoE, silakan ganti menggunakan router untuk menyambung menggunakan PPPoE, dan aktifkan fitur DHCP di router.',
    },
    connecting: 'Menghubungkan...',
    connection_types: {
      ether2ether: 'Sambungan Langsung',
      usb: 'Sambungan USB',
      wifi: 'Wi-Fi',
      wired: 'Jaringan Kabel',
    },
    next: 'Berikutnya',
    no_machine: 'Saya tidak memiliki mesin sekarang.',
    promark: {
      configuration_confirmation: 'Ini memastikan Promark Anda dikonfigurasi dengan benar untuk efisiensi dan akurasi optimal.',
      or_complete_later: `Atau, lewati langkah ini dan lengkapi Pengaturan Promark nanti di:
    Mesin > "Nama Promark" > Pengaturan Promark`,
      qc_instructions: 'Isi parameter yang terletak di bagian belakang kartu "QC Pass"',
      select_laser_source: 'Pilih Promark Anda',
      select_workarea: 'Pilih Area Kerja',
      setting_completed_ask_camera_calibration: 'Pengaturan lensa bidang Promark berhasil diselesaikan! Apakah Anda ingin melanjutkan dengan kalibrasi kamera?',
      settings: 'Pengaturan Promark',
    },
    retry: 'Coba lagi',
    select_beambox: 'Pilih Beambox Anda',
    select_beamo: 'Pilih beamo Anda',
    select_connection_type: 'Bagaimana Anda ingin menyambung?',
    select_hexa: 'Pilih HEXA Anda',
    select_language: 'Pilih Bahasa',
    select_machine_type: 'Pilih Jenis Mesin Anda',
    select_promark: 'Pilih Promark Anda',
    setting_completed: {
      back: 'Kembali',
      great: 'Selamat datang di Beam Studio',
      ok: 'MULAI MEMBUAT',
      setup_later: 'Anda selalu dapat mengatur mesin Anda dari Bilah Judul > "Mesin" > "Pengaturan Mesin"',
      start: 'Mulai',
    },
    skip: 'Lewati',
    start: 'Mulai',
  },
  input_machine_password: {
    connect: 'HUBUNGKAN',
    password: 'Kata Sandi',
    require_password: '"%s" memerlukan kata sandi',
  },
  insecure_websocket: {
    extension_detected: 'Perpanjangan Beam Studio Connect Terdeteksi',
    extension_detected_description: "Kami telah mendeteksi bahwa Anda telah menginstal perpanjangan Beam Studio Connect. Klik 'Konfirmasi' untuk mengalihkan ke HTTPS, atau klik 'Batal' untuk melanjutkan menggunakan HTTP.",
    extension_not_deteced: 'Tidak dapat Mendeteksi Perpanjangan Beam Studio Connect',
    extension_not_deteced_description: "Untuk menggunakan HTTPS, klik 'Konfirmasi' untuk menginstal ekstensi Beam Studio Connect. Setelah menginstal ekstensi, silakan segarkan halaman untuk mengaktifkannya.<br/>Jika tidak, klik tautan di bawah ini untuk melihat cara menggunakan HTTP di Chrome.",
    unsecure_url_help_center_link: '<a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/9935859456271">Tautan</a>',
  },
  keychain_generator: {
    decoration: 'Dekorasi',
    design_preview: 'Pratinjau Desain',
    element: 'Elemen',
    element_size: 'Ukuran',
    emboss: 'Embos',
    exploded_view: 'Tampilan Terurai',
    export_failed: 'Gagal mengimpor gantungan kunci ke kanvas. Silakan coba lagi.',
    hole: 'Lubang',
    hole_options: {
      diameter: 'Diameter',
      hole_type: 'Jenis',
      offset: 'Offset',
      position: 'Posisi',
      thickness: 'Ketebalan',
      type_punch: 'Lubang pons',
      type_ring: 'Cincin',
    },
    import_to_canvas: 'Impor ke kanvas',
    layers: {
      keychain: 'Gantungan Kunci - Garis Luar',
      keychain_deco_emboss: 'Dekorasi Gantungan Kunci - Pemotongan',
      keychain_deco_emboss_guide: 'Dekorasi Gantungan Kunci - Panduan Pemotongan',
      keychain_deco_engraving: 'Dekorasi Gantungan Kunci - Ukiran',
    },
    more_shapes: 'Bentuk Lainnya',
    outline_offset: 'Offset garis luar',
    reset_to_default: 'Atur ulang ke default',
    shape: 'Bentuk',
    size_scale: 'Skala Ukuran',
    switch_type_warning: 'Pengaturan Anda saat ini belum diimpor ke kanvas.\nMengubah jenis gantungan kunci akan mengatur ulang semua pengaturan ke nilai default.',
    text: 'Teks',
    text_options: {
      font_family: 'Keluarga huruf',
      font_settings: 'Pengaturan huruf',
      font_size: 'Ukuran huruf',
      font_style: 'Gaya huruf',
      letter_spacing: 'Jarak huruf',
      line_spacing: 'Jarak baris',
      text_placeholder: 'Masukkan teks...',
    },
    types: {
      animal: 'Gaya Hewan',
      capsule: 'Gaya Kapsul',
      dialog_box: 'Gaya Kotak Dialog',
      geometry: 'Gaya Geometri',
      oval: 'Gaya Oval',
      pet: 'Gaya Hewan Peliharaan',
      plant: 'Gaya Tanaman',
      polygonal: 'Gaya Poligonal',
      quadrilateral: 'Gaya Segi Empat',
      round_arch: 'Gaya Lengkung Bulat',
      rounded: 'Gaya Bulat',
      surfing_board: 'Gaya Papan Selancar',
      tag: 'Gaya Label',
      text: 'Teks',
      zodiac: 'Zodiak',
    },
  },
  layer_module: {
    general_laser: 'Laser',
    laser_2w_infrared: 'Laser Inframerah 2W',
    laser_10w_diode: 'Laser Diode 10W',
    laser_20w_diode: 'Laser Diode 20W',
    non_working_area: 'Area Non-kerja',
    none: 'None',
    notification: {
      convertFromLaserModuleMsg: 'Harap perhatikan bahwa jika Anda menyelesaikan operasi ini, pengaturan lapisan laser akan dihapus dan disesuaikan dengan lapisan saat ini.',
      convertFromLaserModuleTitle: 'Apakah Anda ingin mengubah modul Laser menjadi modul Cetak?',
      convertFromPrintingModuleMsg: 'Harap perhatikan bahwa jika Anda menyelesaikan operasi ini, pengaturan warna lapisan cetak akan dihapus dan disesuaikan dengan lapisan saat ini.',
      convertFromPrintingModuleTitle: 'Apakah Anda ingin mengubah modul Pencetakan menjadi modul Laser?',
      importedDocumentContainsPrinting: 'Dokumen berisi lapisan cetak, apakah Anda ingin mengubah area kerja ke Ador?',
      importedDocumentContainsPrinting4C: 'Dokumen berisi lapisan cetak, apakah Anda ingin mengubah area kerja ke beamo II?',
      performIRCaliMsg: 'Klik "Konfirmasi" untuk mengeksekusi kalibrasi, atau akses kalibrasi melalui menu atas. <br /> (Mesin> [Nama Mesin Anda]> Kalibrasi Modul Inframerah)',
      performIRCaliTitle: 'Lakukan kalibrasi modul Inframerah',
      performPrintingCaliMsg: 'Klik "Konfirmasi" untuk mengeksekusi kalibrasi, atau akses kalibrasi melalui menu atas. <br /> (Mesin> [Nama Mesin Anda]> Kalibrasi Modul Cetak)',
      performPrintingCaliTitle: 'Lakukan kalibrasi modul cetak',
      printingLayersConverted: 'Lapisan cetak telah dikonversi menjadi lapisan laser.',
    },
    printing: 'Pencetakan',
    unknown: 'Unknown Module',
    uv_print: 'Cetak UV',
    uv_varnish: 'Pernis',
    uv_white_ink: 'Tinta putih',
  },
  machine_linking: {
    continue: 'Lanjutkan',
    i_have_read: 'Saya telah membaca',
    input_birthday_to_link: 'Masukkan tanggal lahir Anda untuk menyelesaikan penautan perangkat',
    input_birthday_to_link_note: '*Digunakan untuk memverifikasi apakah usia Anda memenuhi persyaratan kelayakan',
    link_failed: 'Tautan gagal.',
    link_failed_already_linked: 'Perangkat ini saat ini ditautkan ke FLUX ID lain. Anda dapat terus menggunakannya atau menautkannya ke akun Anda.',
    link_failed_cannot_set_secret: 'Tidak dapat menyimpan informasi tautan ke perangkat. Periksa koneksi antara komputer dan perangkat Anda.',
    link_failed_under_age: 'Anda saat ini tidak memenuhi syarat untuk menggunakan layanan ini dan tidak dapat menyelesaikan penautan perangkat.',
    link_machine: 'Tautkan FLUX ID',
    link_machine_to_account: 'Terhubung ke %(name)s. Apakah Anda ingin menautkan perangkat ini ke akun Anda?',
    link_success: 'Tautan berhasil.',
    link_to_my_flux_id: 'Tautkan ke FLUX ID saya',
    privacy_policy: 'Kebijakan Privasi',
    privacy_policy_link: 'https://flux3dp.com/privacy/',
    process_linking: 'Menautkan…',
    use_without_linking: 'Gunakan tanpa menautkan',
  },
  machine_status: {
    '-17': 'Mode Kartrid IO',
    '-10': 'Mode perawatan',
    '-2': 'Pemindaian',
    '-1': 'Pemeliharaan',
    '0': 'Menganggur',
    '1': 'Memulai',
    '2': 'ST_TRANSFORM',
    '4': 'Mulai',
    '6': 'Melanjutkan',
    '16': 'Bekerja',
    '18': 'Melanjutkan',
    '32': 'Dijeda',
    '36': 'Dijeda',
    '38': 'Penjedaan',
    '48': 'Dijeda',
    '50': 'Penjedaan',
    '64': 'Selesai',
    '66': 'Menyelesaikan',
    '68': 'Mempersiapkan',
    '128': 'Dibatalkan',
    '256': 'Alarm',
    '512': 'Fatal',
    UNKNOWN: 'Tidak diketahui',
  },
  maintenance: {
    actions: {
      checked: 'Diperiksa',
      done: 'Selesai',
      fail: 'Gagal',
      history: 'Riwayat',
      open_guide: 'Buka panduan',
      pass: 'Lulus',
      print: 'Cetak / PDF',
    },
    areas: {
      back_cover: 'Penutup belakang',
      modules: 'Modul',
      optics: 'Optik',
      panel: 'Panel',
      working_area: 'Area kerja',
    },
    cadence: {
      by_material: 'Menurut bahan',
      condition: 'Kondisi',
      day: 'Setiap hari',
      days: 'Setiap %s hari',
      each_operation: 'Setiap pengoperasian',
      every_1_2_weeks: 'Setiap 1–2 minggu',
      month: 'Setiap bulan',
      months: 'Setiap %s bulan',
      upon_unboxing: 'Saat pertama kali membuka kemasan',
      week: 'Setiap minggu',
      weeks: 'Setiap %s minggu',
    },
    celebration: {
      subtitle: '%s Anda dalam kondisi prima — pertahankan.',
      title: 'Semua pemeliharaan penting selesai!',
    },
    columns: {
      cadence: 'Frekuensi',
      status: 'Status',
      task: 'Tugas',
    },
    empty_no_machine: 'Hubungkan atau pilih mesin untuk melihat jadwal pemeliharaannya.',
    empty_no_schedule: 'Belum ada daftar periksa pemeliharaan untuk model ini.',
    essential: 'Penting',
    essential_health: 'Kesehatan penting',
    essential_hint: 'dihitung dalam kesehatan',
    feedback: {
      checked: '%s diperiksa.',
      done: '%s baru saja dilakukan. Jatuh tempo berikutnya %s.',
      done_no_date: '%s selesai.',
      fail_warning: '%s: ditandai untuk penggantian tabung. Buka panduan untuk langkah-langkahnya.',
      passed: '%s lulus — tabung dalam kondisi baik!',
    },
    footer_tip: 'Tips: ukir file contoh setiap bulan agar mesin tetap sehat.',
    history_hint: 'Hanya %s entri terbaru yang disimpan untuk setiap tugas.',
    intro: 'Pantau setiap tugas pemeliharaan mesin ini dan tandai selesai dengan satu klik.',
    legend: {
      due_soon: 'Segera jatuh tempo',
      overdue: 'Terlambat',
      up_to_date: 'Terkini',
    },
    machine_groups: {
      my_machines: 'Mesin saya',
      other_models: 'Model lainnya',
    },
    machine_label: 'Mesin',
    materials: {
      acrylic: 'Akrilik',
      leather: 'Kulit',
      paper: 'Kertas',
      wood: 'Kayu',
    },
    status: {
      checked: 'Diperiksa',
      due: 'Jatuh tempo',
      healthy: 'Sehat',
      last: 'Terakhir',
      never_done: 'Belum pernah',
      next: 'Berikutnya',
      not_checked: 'Belum diperiksa',
      not_logged: 'Belum dicatat',
      overdue: 'Terlambat',
      replace_tube: 'Ganti tabung',
    },
    tasks: {
      align: {
        keyPoints: 'Sesuaikan saat jalur optik tidak sejajar.',
        name: 'Penyelarasan Jalur Optik',
      },
      chassis: {
        keyPoints: 'Bersihkan residu dan minyak tar dari sasis dan penutup bawah.',
        name: 'Pembersihan Sasis',
      },
      door: {
        keyPoints: 'Bersihkan minyak dari penutup pintu.',
        name: 'Pembersihan Penutup Pintu',
      },
      exhaust: {
        keyPoints: 'Bersihkan debu dari bilah kipas.',
        name: 'Pembersihan Kipas Pembuangan',
      },
      fan: {
        keyPoints: 'Bersihkan debu dari bilah kipas ventilasi.',
        name: 'Pembersihan Kipas Ventilasi',
      },
      fieldlens: {
        keyPoints: 'Bersihkan lensa bidang, usap dari tengah ke arah luar searah jarum jam.',
        name: 'Pembersihan Lensa Bidang',
      },
      honeycomb_plate: {
        keyPoints: 'Bersihkan residu dan tar dari kisi pelat sarang lebah.',
        name: 'Pembersihan Pelat Sarang Lebah',
      },
      honeycomb_table: {
        keyPoints: 'Bersihkan residu dan minyak tar dari jaring sarang lebah.',
        name: 'Pembersihan Meja Sarang Lebah',
      },
      lube: {
        keyPoints: 'Bersihkan batang pemandu, rel linier, dan mekanisme fokus, lalu lumasi kembali. Frekuensinya bervariasi tergantung bahan yang Anda potong.',
        name: 'Pelumasan',
      },
      maintain_test: {
        keyPoints: 'Periksa tampilan status dan sakelar.',
        name: 'Halaman MAINTAIN',
      },
      mirrors_combiner: {
        keyPoints: 'Bersihkan kotoran dari lensa/cermin; periksa oksidasi. Jangan sisakan bekas alkohol atau air.',
        name: 'Cermin, Lensa Fokus & Beam Combiner',
      },
      mirrors_lens: {
        keyPoints: 'Bersihkan 4 cermin dan lensa; pastikan tidak ada oksidasi atau bekas air.',
        name: 'Pembersihan Cermin & Lensa',
      },
      mod_diode: {
        keyPoints: 'Bersihkan kipas, lensa fokus, dan POGO pin.',
        name: 'Modul Laser Diode',
      },
      mod_ir: {
        keyPoints: 'Bersihkan lensa fokus.',
        name: 'Modul Laser Inframerah',
      },
      optical_inspection: {
        keyPoints: 'Periksa jalur optik; juga saat membuka kemasan dan setelah penggantian tabung.',
        name: 'Pemeriksaan Jalur Optik',
      },
      optical_unboxing: {
        keyPoints: 'Pastikan jalur optik akurat. Periksa saat pertama kali membuka kemasan.',
        name: 'Pemeriksaan Jalur Optik',
      },
      screen: {
        keyPoints: 'Bersihkan debu dan minyak pada panel.',
        name: 'Pembersihan Layar',
      },
      tube: {
        keyPoints: 'Jika akrilik 3 mm tidak dapat dipotong pada daya 70%, ganti tabung.',
        name: 'Pemeriksaan Kesehatan Tabung Laser',
      },
      water: {
        keyPoints: 'Tambahkan air hingga lebih dari 80% penuh tanpa gelembung udara.',
        name: 'Penggantian Air Pendingin',
      },
      worktable: {
        keyPoints: 'Semprotkan alkohol pada tisu, lalu usap meja kerja.',
        name: 'Pembersihan Meja Kerja',
      },
      zaxis: {
        keyPoints: 'Usap sekrup kolom sumbu Z, lalu oleskan pelumas secara merata dengan cotton bud.',
        name: 'Pelumasan Kolom Sumbu Z',
      },
    },
    title: 'Daftar Periksa Pemeliharaan',
  },
  material_test_generator: {
    block_settings: 'Pengaturan Blok',
    columns: 'Kolom',
    count: 'Jumlah',
    cut: 'Potong',
    engrave: 'Ukir',
    export: 'Ekspor',
    max: 'Maks',
    min: 'Min',
    parameter: 'Parameter',
    rows: 'Baris',
    size: 'Ukuran (PxL)',
    spacing: 'Jarak',
    table_settings: 'Pengaturan Tabel',
    text_settings: 'Pengaturan Teks',
    title: 'Generator Uji Material',
  },
  menu: {
    inches: 'Inci',
    mm: 'mm',
  },
  message: {
    auth_error: '#820 Kesalahan Otentikasi: Harap perbarui Beam Studio dan firmware mesin ke versi terbaru.',
    authenticating: 'Mengotentikasi...',
    auto_focus: {
      instruction: 'Silakan pindahkan kepala modul laser di atas objek, dan ikuti instruksi animasi untuk menekan AF untuk fokus.',
      succeeded: 'Berhasil difokuskan',
      title: 'Fokus Otomatis',
      warning_at_coordinates: 'Setelah memasuki mode fokus otomatis, kepala laser akan direset dan dipindahkan ke posisi yang ditentukan untuk memfokuskan.\nPastikan posisi target berada di atas material dan tidak ada rintangan di jalur pergerakan.',
    },
    backend_calculation: {
      analyzing_svg: 'Menganalisis SVG - %d%% ...',
      calculating_task_path: 'Menghitung jalur tugas - %d%% ...',
      finishing: 'Menyelesaikan...',
      initializing: 'Menginisialisasi...',
    },
    camera: {
      abort_preview: 'Batalkan',
      calibration_data_missing: 'Siapkan kalibrasi kamera',
      calibration_data_missing_message: 'Data kalibrasi kamera tidak ada.\nImpor data kalibrasi tersimpan Anda atau lakukan kalibrasi kamera.',
      calibration_wide_angle_camera_first: 'Harap kalibrasi kamera sudut lebar terlebih dahulu.',
      camera_cable_unstable: 'Terdeteksi kamera mentransfer foto secara tidak stabil. Pratinjau masih dapat dilakukan, tetapi mungkin ada masalah lambat atau waktu habis.',
      continue_preview: 'Lanjutkan',
      door_opened: 'Pintu Terbuka',
      door_opened_text: 'Tutup pintu sebelum memulai ulang pratinjau kamera.',
      fail_to_transmit_image: '#845 Terjadi kesalahan transmisi gambar. Harap mulai ulang mesin atau Beam Studio. Jika error berlanjut, ikuti <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/4402756056079">panduan ini</a>.',
      switching_camera: 'Mengganti kamera...',
      wide_angle_open_door: 'Buka pintu penutup',
      wide_angle_open_door_text: 'Buka pintu penutup sebelum beralih ke kamera sudut lebar.',
      ws_closed_unexpectedly: '#844 Koneksi ke kamera mesin ditutup secara tidak terduga. Jika error berlanjut, ikuti <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/4402755805071">panduan ini</a>.',
    },
    cancelling: 'Membatalkan...',
    cant_connect_to_device: '#827 Tidak dapat terhubung ke mesin, harap periksa koneksi Anda',
    connected: 'Terhubung',
    connecting: 'Menghubungkan...',
    connectingCamera: 'Menghubungkan kamera...',
    connectingMachine: 'Menghubungkan %s...',
    connectionTimeout: '#805 Waktu Koneksi Perangkat Habis. Silakan periksa koneksi jaringan Anda dan indikator Wi-Fi mesin.',
    device_blocked: {
      caption: 'Nomor Seri Tidak Sah',
      offline: 'Nomor seri perangkat Anda dibatasi untuk penggunaan offline karena tampaknya dinonaktifkan. Silakan berikan nomor seri perangkat (terletak di bagian belakang perangkat) kepada penjual Anda dan minta mereka menghubungi support@flux3dp.com untuk mengaktifkan otorisasi online. Jika Anda ingin menggunakan perangkat secara offline, silakan hubungi support@flux3dp.com langsung.',
      online: 'Nomor seri perangkat Anda tampaknya dinonaktifkan. Silakan berikan nomor seri perangkat (terletak di bagian belakang perangkat) kepada penjual Anda dan minta mereka menghubungi support@flux3dp.com untuk mengaktifkan otorisasi perangkat.',
    },
    device_busy: {
      caption: 'Mesin Sibuk',
      message: 'Mesin sedang mengerjakan tugas lain, coba lagi nanti. Jika berhenti bekerja, harap mulai ulang mesin.',
    },
    device_is_used: 'Mesin sedang digunakan, apakah Anda ingin membatalkan tugas saat ini?',
    device_not_found: {
      caption: 'Mesin Default tidak ditemukan',
      message: '#812 Silakan periksa indikator Wi-Fi mesin',
    },
    disconnected: 'Koneksi tidak stabil, harap periksa koneksi perangkat dan coba lagi nanti',
    endingLineCheckMode: 'Keluar dari mode pemeriksaan garis...',
    endingRawMode: 'Keluar dari Mode Kontrol Mesin...',
    enteringLineCheckMode: 'Memasuki mode pemeriksaan garis...',
    enteringRawMode: 'Memasuki Mode Kontrol Mesin...',
    enteringRedLaserMeasureMode: 'Memasuki mode pengukuran laser merah...',
    exitingRotaryMode: 'Keluar dari mode putar...',
    getProbePosition: 'Mendapatkan Posisi Probe...',
    gettingLaserSpeed: 'Membaca kecepatan kepala laser...',
    homing: 'Melakukan pengaturan awal...',
    mac_os_arch_mismatch: {
      caption: 'Instal ulang versi yang kompatibel',
      download_center: 'Pusat Unduhan',
      message: 'Mac ini menggunakan Apple Silicon. Unduh versi Apple Silicon dan instal ulang.',
    },
    need_password: 'Memerlukan Kata Sandi untuk Menghubungkan ke Mesin',
    please_enter_dpi: 'Harap masukkan Satuan file Anda (dalam mm)',
    preview: {
      adjust: 'Sesuaikan',
      adjust_height_tooltip: 'Centang kotak untuk mengaktifkan penyuntingan.',
      already_performed_auto_focus: 'Anda sudah melakukan fokus otomatis, gunakan nilai yang ada?',
      camera_preview: 'Pratinjau Kamera',
      capturing_image: 'Mengambil gambar...',
      enter_manually: 'Masukkan Secara Manual',
      getting_focal_distance: 'Mengambil jarak fokus...',
      moving_to_preview_position: 'Memindahkan ke posisi pratinjau...',
      please_enter_height: 'Silakan masukkan tinggi objek agar dapat mengambil gambar kamera yang akurat.',
      please_focus_before_preview: 'Untuk mendapatkan kualitas pratinjau yang lebih baik, silakan lakukan fokus otomatis sebelum pratinjau.',
      press_esc_to_stop: 'Tekan ESC untuk menghentikan pratinjau kamera.',
      succeeded: 'Berhasil dipratinjau',
    },
    promark_disconnected: '#850 Koneksi perangkat terputus, periksa status koneksi perangkat.',
    redLaserTakingReference: 'Mengambil referensi...',
    retrievingCameraOffset: 'Membaca offset kamera...',
    settingLaserSpeed: 'Mengatur kecepatan kepala laser...',
    swiftray_disconnected: 'Tidak dapat terhubung ke backend, mencoba menghubungkan ulang.',
    swiftray_reconnected: 'Backend telah terhubung kembali, silakan coba kirim ulang pekerjaan.',
    time_remaining: 'Waktu tersisa:',
    tryingToConenctMachine: 'Mencoba menyambungkan ke mesin...',
    turningOffAirPump: 'Mematikan pompa udara...',
    turningOffFan: 'Mematikan kipas...',
    unable_to_find_machine: 'Tidak dapat menemukan mesin',
    unable_to_start: '#830 Tidak dapat memulai tugas. Harap coba lagi. Jika ini terjadi lagi, hubungi kami dengan laporan bug:',
    unavailableWorkarea: '#804 Area kerja saat ini melebihi area kerja mesin ini. Harap periksa area kerja mesin yang dipilih atau atur area kerja dari Edit > Pengaturan Dokumen.',
    unknown_device: '#826 Tidak dapat terhubung ke mesin, pastikan USB terpasang ke mesin',
    unknown_error: '#821 Aplikasi mengalami kesalahan yang tidak diketahui, harap gunakan Bantuan > Menu > Laporan Bug.',
    unsupport_osx_version: 'Versi macOS %s saat ini mungkin tidak mendukung beberapa fungsi. Harap perbarui ke macOS 13+.',
    unsupport_win_version: 'Versi OS %s saat ini mungkin tidak mendukung beberapa fungsi. Harap perbarui ke versi terbaru.',
    unsupported_example_file: 'File contoh yang dipilih tidak didukung oleh area kerja saat ini.',
    uploading_fcode: 'Mengunggah FCode',
    usb_unplugged: 'Koneksi USB terputus. Harap periksa koneksi USB Anda',
    wrong_swiftray_version_message: 'Versi backend salah (versi: {version}). Harap periksa apakah beberapa instance Beam Studio sedang berjalan dan tutup instance tambahan sebelum mencoba lagi.',
    wrong_swiftray_version_title: 'Versi backend salah',
  },
  monitor: {
    ask_reconnect: 'Koneksi dengan mesin telah terputus. Apakah Anda ingin menyambungkan kembali?',
    bug_report: 'Laporan Bug',
    camera: 'Kamera',
    cancel: 'Batalkan',
    confirmFileDelete: 'Apakah Anda yakin ingin menghapus file ini?',
    connecting: 'Menghubungkan, mohon tunggu...',
    DEVICE_ERROR: 'Ada kesalahan\nHarap mulai ulang mesin',
    download: 'Unduh',
    extensionNotSupported: 'Format file ini tidak didukung',
    fileExistContinue: 'File sudah ada, apakah Anda ingin menggantinya?',
    forceStop: 'Apakah Anda ingin membatalkan tugas saat ini?',
    go: 'Mulai',
    HARDWARE_ERROR_AIR_ASSIST_ABNORMAL: '#913 Sensor aliran udara abnormal',
    HARDWARE_ERROR_BOTTOM_OPENED: '#903 Bawah Terbuka. Tutup bagian bawah untuk melanjutkan.',
    HARDWARE_ERROR_CARTRIDGE_OVERHEAT: '#931 Peringatan Suhu Kartrid Tinta\nSuhu kartrid tinta melebihi batas normal.\nUntuk perlindungan, pekerjaan telah dihentikan. Silakan pasang ulang kartrid tinta dan mulai ulang pekerjaan.',
    HARDWARE_ERROR_CARTRIDGE_POWERON_FAILED: '#930 Pasang ulang kartrid tinta\nKoneksi buruk terdeteksi pada kartrid tinta. Silakan pasang ulang kartrid tinta dan coba lagi.',
    HARDWARE_ERROR_COVER_NOT_CLOSED: '#924 Gagal memasang penutup kepala cetak',
    HARDWARE_ERROR_COVER_NOT_OPENED: '#925 Gagal melepas penutup kepala cetak',
    HARDWARE_ERROR_DOOR_OPENED: '#901 Tutup pintu untuk melanjutkan.',
    HARDWARE_ERROR_DRAWER_OPENED: '#911 Laci terbuka',
    HARDWARE_ERROR_FIRE_DETECTED: '#912 Sensor api anomali',
    HARDWARE_ERROR_HEADTYPE_MISMATCH: '#915 Terdeteksi modul yang salah. Mohon pasang modul yang benar untuk melanjutkan.',
    HARDWARE_ERROR_HEADTYPE_NONE: '#917 Tidak terdeteksi modul. Pastikan modul terpasang dengan benar untuk melanjutkan.',
    HARDWARE_ERROR_HEADTYPE_UNKNOWN: '#918 Terdeteksi modul yang tidak diketahui. Pasang modul yang benar untuk melanjutkan.',
    HARDWARE_ERROR_HOMING_PULLOFF_FAILED: '#920 Kesalahan Tarik Lepas Penghomatan',
    HARDWARE_ERROR_KEY_OFF: '#929 Kunci Keamanan Tidak Terdeteksi\nKunci keamanan tidak terdeteksi atau telah dinonaktifkan. Demi keselamatan Anda, mesin tidak dapat beroperasi sampai kunci diaktifkan dengan benar.\nSilakan masukkan kunci keamanan dan nyalakan sebelum memulai ulang pekerjaan.',
    HARDWARE_ERROR_LASER_TEMPERATURE_ABNORMAL: '#933 Suhu Laser Abnormal\nSuhu laser terlalu tinggi. Silakan hentikan operasi dan biarkan laser mendingin sebelum memulai ulang.',
    HARDWARE_ERROR_LASER_VOLTAGE_ABNORMAL: '#932 Tegangan Laser Abnormal\nKesalahan tegangan laser. Silakan mulai ulang mesin. Jika masalah berlanjut, hubungi dukungan pelanggan.',
    HARDWARE_ERROR_MAINBOARD_ERROR: '#401 Kesalahan Kritis: Papan utama offline. Silakan hubungi Dukungan FLUX.',
    HARDWARE_ERROR_MAINBOARD_NO_RESPONSE: '#928 Papan Utama Tidak Merespons\nPapan utama tidak merespons. Silakan mulai ulang pekerjaan.',
    HARDWARE_ERROR_OVER_TEMPERATURE: '#902 Terlalu panas. Mohon tunggu beberapa menit.',
    HARDWARE_ERROR_PLATFORM_HOMING_FAILED: '#910 Reset sumbu Z gagal',
    HARDWARE_ERROR_PRINTER_NO_RESPONSE: '#919 Tidak ada respon dari modul printer.',
    HARDWARE_ERROR_PROBE_SHOWED: 'Harap tarik kembali probe.',
    HARDWARE_ERROR_PUMP_ERROR: '#900 Aliran pendingin rendah. Silakan periksa dengan tangki air Anda.',
    HARDWARE_ERROR_REMOTE_INTERLOCK_OPENED: '#927 Interlock Jarak Jauh Terpicu\nSilakan periksa konektor interlock jarak jauh dan pastikan terhubung dengan aman sebelum memulai ulang pekerjaan.',
    HARDWARE_ERROR_ROTARY_NOT_DETECTED: '#914 Tidak terdeteksi modul putar',
    HARDWARE_ERROR_SUBSYSTEM_ERROR: '#402 Kesalahan Kritis: Subsistem tidak merespons. Silakan hubungi Dukungan FLUX.',
    HARDWARE_FAILURE: 'Ada kesalahan\nHarap mulai ulang mesin',
    hour: 'j',
    left: 'kiri',
    MAINBOARD_OFFLINE: '#905 Kesalahan saat menyambung ke papan utama.\nHarap mulai ulang mesin.',
    minute: 'm',
    monitor: 'MONITOR',
    NO_RESPONSE: '#905 Kesalahan saat menyambung ke papan utama.\nHarap mulai ulang mesin.',
    no_task_info: 'Saat ini tidak ada tugas yang dapat ditampilkan.',
    pause: 'Jeda',
    prepareRelocate: 'Persiapan untuk Pindah',
    processing: 'Memproses',
    record: 'Rekam',
    relocate: 'Pindahkan',
    RESOURCE_BUSY: 'Mesin sibuk\nJika tidak berjalan, harap mulai ulang mesin',
    resume: 'Lanjutkan',
    savingPreview: 'Membuat gambar mini',
    second: 'd',
    start: 'Mulai',
    stop: 'Berhenti',
    SUBSYSTEM_ERROR: '#402 Kesalahan Kritis: Subsistem tidak merespons. Harap hubungi Dukungan FLUX.',
    task: {
      BEAMBOX: 'Pemotongan Laser',
      'N/A': 'Mode Bebas',
    },
    taskTab: 'Tugas',
    temperature: 'Suhu',
    upload: 'Unggah',
    USER_OPERATION: 'Silakan ikuti petunjuk di panel perangkat untuk melanjutkan.',
    USER_OPERATION_CARTRIDGE_INK_EMPTY: 'Kartrid Kosong\nKartrid kehabisan tinta. Ganti kartrid untuk melanjutkan pencetakan.',
    USER_OPERATION_CARTRIDGE_INK_LOW: 'Tingkat Tinta Rendah\nTinta di kartrid hampir habis. Kami sarankan segera mengganti kartrid.',
    USER_OPERATION_CHANGE_CARTRIDGE: 'Silakan masukkan kartrid yang benar untuk melanjutkan.',
    USER_OPERATION_CHANGE_CARTRIDGE_CARTRIDGE_NOT_DETECTED: 'Silakan masukkan kartrid untuk melanjutkan.',
    USER_OPERATION_CHANGE_TOOLHEAD: 'Pasang modul yang benar untuk melanjutkan.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_MISMATCH: '#915 Terdeteksi modul yang salah. Mohon pasang modul yang benar untuk melanjutkan.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_NONE: '#917 Tidak terdeteksi modul. Pastikan modul terpasang dengan benar untuk melanjutkan.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_UNKNOWN: '#918 Terdeteksi modul yang tidak diketahui. Pasang modul yang benar untuk melanjutkan.',
    USER_OPERATION_REMOVE_CARTRIDGE: 'Harap lepas kartrid untuk melanjutkan.',
    USER_OPERATION_ROTARY_PAUSE: 'Harap beralih ke motor putar.',
    USER_OPERATION_USER_Z_AXIS_CHECK_REQUIRED: 'Pengingat Fokus\nFokuskan ulang sebelum memulai pekerjaan baru untuk memastikan hasil yang akurat.',
  },
  my_cloud: {
    action: {
      confirmFileDelete: 'Apakah Anda yakin ingin menghapus berkas ini? Tindakan ini tidak dapat dibatalkan.',
      delete: 'Hapus',
      download: 'Unduh',
      duplicate: 'Duplikat',
      open: 'Buka',
      rename: 'Ubah Nama',
    },
    file_limit: 'File gratis',
    loading_file: 'Memuat...',
    no_file_subtitle: 'Buka Menu > "Berkas" > "Simpan ke Awan"',
    no_file_title: 'Simpan berkas ke Awan Saya untuk memulai.',
    not_login_title: 'Masuk untuk menyimpan file Anda ke Cloud.',
    save_file: {
      choose_action: 'Simpan Berkas:',
      input_file_name: 'Masukkan nama berkas:',
      invalid_char: 'Karakter tidak valid:',
      save: 'Simpan',
      save_new: 'Simpan sebagai berkas baru',
      storage_limit_exceeded: 'Penyimpanan cloud Anda telah mencapai batas atas. Harap hapus file yang tidak diperlukan sebelum menyimpan file baru.',
    },
    sort: {
      a_to_z: 'Nama: A - Z',
      most_recent: 'Terbaru',
      oldest: 'Terlama',
      z_to_a: 'Nama: Z - A',
    },
    title: 'Awan Saya',
    upgrade: 'Tingkatkan',
  },
  noun_project_panel: {
    clear: 'Hapus',
    elements: 'Elemen',
    enjoy_shape_library: 'Nikmati basis data bentuk.',
    export_svg_title: 'Tidak dapat Mengekspor SVG',
    export_svg_warning: 'Proyek ini berisi objek yang dilindungi oleh hukum kekayaan intelektual. Oleh karena itu Beam Studio akan secara otomatis mengecualikan objek-objek ini selama ekspor. Anda masih dapat menyimpan proyek Anda dalam format Beam Studio Scene (.beam) untuk menyimpan seluruh data Anda. Apakah Anda masih ingin mengekspor?',
    learn_more: 'Pelajari Lebih Lanjut',
    login_first: 'Masuk untuk membuka basis data bentuk.',
    recent: 'Terbaru',
    search: 'Cari',
    shapes: 'Bentuk',
  },
  pass_through: {
    export: 'Ekspor ke Area Kerja',
    exporting: 'Mengekspor...',
    guide_mark: 'Tanda Panduan',
    guide_mark_desc: 'Tanda panduan akan diukir sebagai titik referensi untuk menyelaraskan karya seni.',
    guide_mark_length: 'Panjang:',
    guide_mark_x: 'Koordinat X:',
    height_desc: 'Atur ketinggian setiap bagian area kerja.',
    help_links: {
      ado1: 'https://support.flux3dp.com/hc/en-us/articles/10140002160399',
      fbb2: 'https://support.flux3dp.com/hc/en-us/articles/11570021253263',
    },
    help_text: 'Bagaimana cara mengatur Lewat Langsung untuk %(model)s?',
    object_length: 'Panjang Objek',
    ref_layer: 'Lapisan Referensi',
    ref_layer_desc: 'Harap dicatat bahwa eksekusi lapisan referensi secara default diatur ke 0. Itu tidak akan dieksekusi tetapi hanya untuk referensi penyelarasan.',
    ref_layer_name: 'Referensi',
    title: 'Mode Lewat Langsung',
    workarea_height: 'Area Kerja (Tinggi):',
  },
  promark_connection_test: {
    description: 'Sistem akan menjalankan operasi lampu merah selama sekitar dua menit untuk memeriksa apakah koneksi stabil.',
    health: 'Stabilitas:',
    healthy_description: 'Stabilitas baik, tetapi hindari menggerakkan komputer secara signifikan selama proses gravir.',
    res_0: 'Sangat Baik',
    res_1: 'Baik',
    res_2: 'Rendah',
    res_3: 'Terlalu Rendah',
    res_4: 'Sangat Rendah',
    restart: 'Ulangi Tes',
    start: 'Mulai Tes',
    stop: 'Hentikan Tes',
    title: 'Tes Stabilitas Koneksi',
    unhealthy_description: 'Stabilitas terlalu rendah. Disarankan untuk mengganti adaptor jaringan atau kabel daya.',
  },
  promark_settings: {
    angle: 'Sudut',
    bulge: 'Tonjolan',
    field: 'Bidang',
    galvo_configuration: 'Konfigurasi Galvo',
    mark: 'Tandai',
    mark_parameters: 'Parameter Penandaan',
    offsetX: 'Penggeseran X',
    offsetY: 'Penggeseran Y',
    red_dot: 'Titik Merah',
    scale: 'Skala',
    scaleX: 'Skala X',
    scaleY: 'Skala Y',
    skew: 'Kemiringan',
    switchXY: 'Tukar X/Y',
    title: 'Pengaturan Promark',
    trapezoid: 'Trapesium',
    workarea_hint: 'Anda dapat mengubah area kerja di "Pengaturan Dokumen".',
    z_axis_adjustment: {
      section1: 'Sesuaikan ketinggian sumbu Z untuk menyempurnakan fokus.',
      title: 'Penyesuaian Sumbu Z',
      tooltip1: 'Cobalah menandai kotak 1x1 cm untuk memastikan jarak fokus saat ini sesuai.',
    },
  },
  puzzle_generator: {
    bleed: 'Bleed',
    board_base: 'Dasar papan',
    board_radius: 'Radius bingkai',
    board_width: 'Lebar bingkai',
    change_image: 'Klik untuk mengubah gambar',
    columns: 'Kolom',
    design_preview: 'Pratinjau desain',
    exploded_view: 'Tampilan terpisah',
    export_as: 'Ekspor sebagai',
    export_engrave: 'Layer ukiran',
    export_failed: 'Gagal mengimpor puzzle ke canvas. Silakan coba lagi atau sesuaikan pengaturan puzzle.',
    export_none: 'Tidak ada',
    export_print: 'Layer cetak',
    file_too_large: 'File yang dipilih melebihi ukuran maksimum yang diizinkan.',
    guide_lines: 'Garis panduan',
    heart_sharpness: 'Ketajaman ujung',
    image: 'Gambar',
    image_load_failed: 'Gagal memuat gambar yang dipilih. Silakan coba file lain.',
    image_resolution_warning: 'Resolusi gambar melebihi %(resolution)spx. Ini mungkin mempengaruhi kualitas ekspor atau kinerja.',
    import_to_canvas: 'Impor ke canvas',
    layers: {
      board_base: 'Dasar papan',
      guide_lines: 'Garis panduan',
      image: 'Gambar puzzle',
      pieces: 'Potongan puzzle',
      raised_edges: 'Tepi terangkat',
    },
    offset_x: 'Offset X',
    offset_y: 'Offset Y',
    orientation: 'Orientasi potongan',
    orientation_type_1: 'Tipe 1',
    orientation_type_2: 'Tipe 2',
    orientation_type_3: 'Tipe 3',
    orientation_type_4: 'Tipe 4',
    piece_size: 'Ukuran potongan',
    preview_placeholder: 'Pratinjau puzzle',
    puzzle_board: 'Papan puzzle',
    puzzle_pieces: 'Potongan puzzle',
    radius: 'Radius',
    raised_edges: 'Tepi timbul',
    reset_to_default: 'Reset ke default',
    rows: 'Baris',
    switch_type_warning: 'Pengaturan Anda saat ini belum diimpor ke canvas.\nMengubah jenis puzzle akan mengatur ulang semua pengaturan ke nilai default.',
    tab_size: 'Ukuran tab',
    types: {
      circle_jigsaw: 'Puzzle lingkaran',
      heart_jigsaw: 'Puzzle berbentuk hati',
      hex_jigsaw: 'Puzzle heksagonal',
      rectangle_jigsaw: 'Puzzle persegi panjang',
    },
    unsupported_file_type: 'Tipe file tidak didukung. Gunakan JPG, PNG, atau WebP.',
    upload_hint: 'JPG, PNG, WebP (maks 10MB)',
    upload_image: 'Klik atau seret untuk mengunggah',
    zoom: 'Zoom',
  },
  qr_code_generator: {
    error_tolerance: 'Toleransi Kesalahan',
    error_tolerance_link: 'https://support.flux3dp.com/hc/en-us/articles/9113705072143',
    invert: 'Balik warna latar belakang',
    placeholder: 'Masukkan teks',
    title: 'Pembuat Kode QR',
  },
  resolution: {
    title: 'Resolusi',
    values: {
      detailed: 'Ultra Halus',
      high: 'Halus',
      low: 'Draf',
      medium: 'Standar',
      mixed: 'Campuran',
      ultra: 'Ultra HD',
    },
  },
  rotary_settings: {
    circumference: 'Keliling',
    extend_workarea: 'Perluas area kerja',
    mirror: 'Cermin',
    object_diameter: 'Diameter Objek',
    overlap_size: 'Ukuran tumpang tindih',
    rotary_scale: 'Skala Rotasi',
    split_setting: 'Pengaturan pemisahan',
    split_setting_url: 'https://support.flux3dp.com/hc/en-us/articles/12276094010767',
    split_size: 'Ukuran pemisahan',
    type: 'Jenis',
  },
  select_device: {
    auth_failure: '#811 Autentikasi gagal',
    select_device: 'Pilih Perangkat',
    unable_to_connect: '#810 Tidak dapat membangun koneksi stabil dengan mesin',
  },
  settings: {
    anti_aliasing: 'Anti-Aliasing',
    auto_connect: 'Pilih otomatis satu-satunya mesin',
    auto_switch_tab: 'Sakelar Otomatis Panel Lapisan dan Objek',
    autofocus_offset: 'Offset Fokus Otomatis',
    autosave_enabled: 'Simpan Otomatis',
    autosave_interval: 'Simpan Setiap',
    autosave_number: 'Jumlah Simpan Otomatis',
    autosave_path: 'Lokasi Simpan Otomatis',
    autosave_path_not_correct: 'Lokasi yang ditentukan tidak ditemukan.',
    blade_precut_position: 'Posisi Pra-pemotongan',
    blade_precut_switch: 'Pra-pemotongan Bilah',
    blade_radius: 'Jari-jari Bilah',
    bottom_up: 'Bawah-atas',
    calculation_optimization: 'Percepatan Perhitungan Jalur',
    cancel: 'Batal',
    caption: 'Pengaturan',
    check_updates: 'Periksa pembaruan secara otomatis',
    close: 'Tutup',
    confirm_remove_default: 'Mesin standar akan dihapus.',
    confirm_reset: 'Konfirmasi atur ulang Beam Studio?',
    continuous_drawing: 'Gambar Kontinu',
    crop_task_thumbnail: 'Thumbnail potong konten',
    crop_task_thumbnail_tooltip: 'Tampilkan hanya thumbnail dari area yang berisi konten, kecuali area kanvas kosong.',
    custom_preview_height: 'Tinggi Pratinjau Kustom',
    default_beambox_model: 'Pengaturan Dokumen Default',
    default_borderless_mode: 'Buka Bawah Default',
    default_enable_autofocus_module: 'Autofokus Default',
    default_enable_diode_module: 'Laser Diode Default',
    default_font_family: 'Font Default',
    default_font_style: 'Gaya Font Default',
    default_laser_module: 'Modul Laser Default',
    default_machine: 'Mesin Standar',
    default_machine_button: 'Kosong',
    default_units: 'Satuan Standar',
    diode_offset: 'Offset Laser Diode',
    diode_one_way_engraving: 'Grafir Laser Diode Satu Arah',
    diode_two_way_warning: 'Pancaran cahaya dua arah lebih cepat dan mungkin menghasilkan ketidaktepatan posisi ukiran laser. Disarankan untuk menguji terlebih dahulu.',
    disabled: 'Nonaktif',
    done: 'Terapkan',
    enable_custom_backlash: 'Aktifkan Kompensasi Backlash Kustom',
    enable_low_speed: 'Aktifkan gerakan kecepatan lambat',
    enable_uv_print_file: 'Aktifkan File Cetak UV',
    enabled: 'Diaktifkan',
    engraving_direction: 'Arah',
    engraving_offset_tooltip: 'Jika hasil ukiran bergeser ke kiri atau ke atas, harap kurangi offset X/Y; jika bergeser ke kanan atau ke bawah, harap tingkatkan offset X/Y.',
    fast_gradient: 'Optimasi Kecepatan',
    font_convert: 'Konverter Teks ke Jalur',
    font_substitute: 'Ganti Karakter yang Tidak Didukung',
    grouped_objects: 'Objek Terkelompok',
    groups: {
      ador_modules: 'Modul Ador',
      autosave: 'Simpan Otomatis',
      beamo2_modules: 'Modul beamo 2',
      camera: 'Kamera',
      connection: 'Koneksi',
      editor: 'Editor',
      engraving: 'Raster (Pemindaian)',
      general: 'Umum',
      mask: 'Pemotongan Area Kerja',
      module_settings: 'Pengaturan Modul',
      module_type: 'Modul Mesin',
      modules: 'Add-on',
      path: 'Vektor (Garis Luar)',
      performance: 'Kinerja',
      privacy: 'Privasi',
      text: 'Teks',
      text_to_path: 'Teks',
      update: 'Pembaruan Perangkat Lunak',
      workarea: 'Area Kerja',
    },
    guess_poke: 'Cari alamat IP mesin',
    guides: 'Panduan',
    guides_origin: 'Asal Panduan',
    help_center_urls: {
      anti_aliasing: 'https://support.flux3dp.com/hc/en-us/articles/360004408956',
      calculation_optimization: 'https://support.flux3dp.com/hc/en-us/articles/11146997425039',
      connection: 'https://support.flux3dp.com/hc/en-us/sections/360000302135',
      continuous_drawing: 'https://support.flux3dp.com/hc/en-us/articles/360004406496',
      default_borderless_mode: 'https://support.flux3dp.com/hc/en-us/articles/360001104076',
      default_enable_autofocus_module: 'https://support.flux3dp.com/hc/en-us/articles/360001574536',
      default_enable_diode_module: 'https://support.flux3dp.com/hc/en-us/articles/360001568035',
      fast_gradient: 'https://support.flux3dp.com/hc/en-us/articles/360004496235',
      font_convert: 'https://support.flux3dp.com/hc/en-us/articles/9132766761743',
      font_substitute: 'https://support.flux3dp.com/hc/en-us/articles/360004496575',
      image_downsampling: 'https://support.flux3dp.com/hc/en-us/articles/360004494995',
      loop_compensation: 'https://support.flux3dp.com/hc/en-us/articles/360004408856',
      mask: 'https://support.flux3dp.com/hc/en-us/articles/360004408876',
      segmented_engraving: 'https://support.flux3dp.com/hc/en-us/articles/12306366019215',
      simplify_clipper_path: 'https://support.flux3dp.com/hc/en-us/articles/360004407276',
      uv_print_export: 'https://support.flux3dp.com/hc/en-us/articles/12320887477135',
      vector_speed_constraint: 'https://support.flux3dp.com/hc/en-us/articles/360004496495',
    },
    high: 'Tinggi',
    image_downsampling: 'Kualitas Pratinjau Bitmap',
    ip: 'Alamat IP Mesin',
    keep_preview_result: 'Pertahankan Hasil Pratinjau',
    language: 'Bahasa',
    loop_compensation: 'Kompensasi Loop',
    low: 'Rendah',
    low_laser_for_preview: 'Laser untuk Jalankan Bingkai',
    mask: 'Pemotongan Area Kerja',
    medium: 'Sedang',
    module_offset_2w_ir: 'Offset Laser Inframerah 2W',
    module_offset_10w: 'Offset Laser Diode 10W',
    module_offset_20w: 'Offset Laser Diode 20W',
    module_offset_laser: 'Offset Laser',
    module_offset_printer: 'Offset Printer',
    none: 'Tidak Ada',
    normal: 'Tinggi',
    notification_off: 'Mati',
    notification_on: 'Menyala',
    notifications: 'Notifikasi Desktop',
    off: 'Mati',
    on: 'Hidup',
    preview_movement_speed: 'Kecepatan Pratinjau Gerakan',
    printer_advanced_mode: 'Mode Printer Lanjutan',
    printing_offset_tooltip: 'Jika hasil cetak bergeser ke kiri atau ke atas, harap kurangi offset X/Y; jika bergeser ke kanan atau ke bawah, harap tingkatkan offset X/Y.',
    remove_default_machine_button: 'Hapus',
    reset: 'Atur ulang Beam Studio',
    reset_now: 'Atur ulang Beam Studio',
    segmented_engraving: 'Pengukiran tersegmentasi',
    share_with_flux: 'Bagikan Analitik Beam Studio',
    show_banners: 'Tampilkan spanduk beranda',
    simplify_clipper_path: 'Optimasi Titik Jangkar',
    single_object: 'Objek Tunggal',
    tabs: {
      device: 'Mesin',
      general: 'Umum',
    },
    text_path_calc_optimization: 'Optimasi Perhitungan Jalur',
    top_down: 'Atas-bawah',
    trace_output: 'Keluaran Lacak Gambar',
    update_beta: 'Beta',
    update_latest: 'Terbaru',
    use_real_boundary: 'Gunakan jangkauan maksimum',
    use_real_boundary_tooltip: 'Perluas ke area kerja maksimum aktual, tanpa batasan garis kisi bilangan bulat.',
    use_union_boundary: 'Tampilkan area kerja yang tumpang tindih',
    use_union_boundary_tooltip: 'Tampilkan area kerja yang tumpang tindih dari beberapa modul',
    vector_order_optimization: 'Optimasi Urutan Vektor',
    vector_speed_constraint: 'Batas Kecepatan',
    wrong_ip_format: 'Format IP salah',
  },
  social_media: {
    facebook: 'Berkolaborasi dengan FLUXers, ajukan pertanyaan, dan pelajari tips!',
    instagram: 'Dapatkan inspirasi terbaru, penawaran, dan hadiah gratis!',
    youtube: 'Lihat tutorial Beam Studio dan ide kerajinan.',
  },
  stamp_maker_panel: {
    bevel_radius: 'Radius Bevel',
    horizontal_flip: 'Balik Horizontal',
    how_to: {
      text: 'Bagaimana cara membuat stempel?',
      url: 'https://support.flux3dp.com/hc/en-us/articles/13658787903247',
    },
    invert: 'Balikkan',
    title: 'Pembuat Stempel',
  },
  support: {
    no_vcredist: 'Mohon instal Visual C++ Redistributable 2015<br/>Dapat diunduh di flux3dp.com',
    no_webgl: 'WebGL tidak didukung. Harap gunakan perangkat lain.',
  },
  tab_panel: {
    apply: 'Terapkan Tab',
    gap: 'Celah',
    help_center: 'https://support.flux3dp.com/hc/en-us/articles/12441363882511',
    manual_mode: 'Mode Manual',
    title: 'Tab',
  },
  tips: {
    canvas_hold_space_to_pan: 'Tahan tombol Spasi dan seret untuk menggeser kanvas.',
    feature_auto_fit: 'Setelah pratinjau kamera, gunakan Tindakan → Penyesuaian Otomatis untuk menempatkan objek secara otomatis pada material Anda.',
    feature_box_generator: 'Gunakan Generator → Generator Kotak untuk membuat kotak berukuran khusus dalam hitungan detik.',
    feature_code_generator: 'Gunakan Generator → Generator Barcode untuk membuat kode QR dan barcode.',
    feature_elements: 'Panel Elemen sekarang mencakup lebih dari satu juta grafis yang siap digunakan.',
    feature_layer_color_configurations: 'Petakan warna lapisan SVG ke kecepatan dan daya melalui Edit → Lapisan → Pengaturan Warna.',
    feature_material_test: 'Gunakan Generator → Generator Uji Material di toolbar kiri untuk dengan cepat menemukan pengaturan terbaik untuk material.',
    layer_execution_order: 'Urutan lapisan menentukan urutan pekerjaan. Pekerjaan berjalan dari atas ke bawah.',
    machine_clean_mirror: 'Periksa cermin dan lensa fokus secara teratur dan bersihkan jika perlu untuk mencegah penumpukan asap.',
    machine_no_unattended_operation: 'Jangan pernah meninggalkan mesin berjalan tanpa pengawasan.',
    machine_regular_start: 'Jalankan pekerjaan laser setidaknya sekali setiap dua minggu untuk membantu memperpanjang masa pakai tabung laser.',
    object_edit_image_to_erase: 'Gunakan Gambar → Tindakan → Edit Gambar untuk menghapus area yang tidak diinginkan dalam gambar.',
    object_polygon_sides: 'Sesuaikan jumlah sisi di panel properti poligon.',
    object_rounded_rectangle: 'Atur radius sudut persegi panjang membulat di panel properti persegi panjang.',
    object_sharpen_portrait: 'Tingkatkan ukiran potret dengan Gambar → Tindakan → Pertajam.',
    settings_auto_save: 'Aktifkan Simpan Otomatis di Preferensi untuk menghindari kehilangan pekerjaan Anda.',
    settings_default_text_font: 'Anda dapat mengatur font default untuk alat Teks di Preferensi.',
    task_focus_lower_for_cutting: 'Untuk material yang lebih tebal, memfokuskan sekitar 2 mm di bawah permukaan dapat meningkatkan hasil pemotongan.',
    task_leather_moisten_reduce_burn: 'Basahi kulit sedikit sebelum memotong untuk mengurangi bekas terbakar.',
    task_parameters_for_promark_color: 'Sesuaikan lebar pulsa dan frekuensi pada laser MOPA untuk menghasilkan warna pada stainless steel atau titanium.',
    task_slower_for_smoother_acrylic_edge: 'Mengurangi kecepatan pemotongan sedikit dapat menghasilkan tepi akrilik yang lebih halus.',
    tips: 'Tips:',
  },
  topbar: {
    alerts: {
      add_content_first: 'Silakan tambahkan objek terlebih dahulu',
      close_door_before_framing: 'Tutup pintu sebelum memulai pratinjau pembingkaian.',
      door_opened: 'Harap tutup pintu penutup untuk mengaktifkan laser rendah agar bingkai dapat berjalan.',
      fail_to_connect_with_camera: '#803 Gagal membuat koneksi dengan kamera mesin. Harap mulai ulang mesin Anda atau Beam Studio. Jika kesalahan ini berlanjut, ikuti <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">panduan ini</a>.',
      fail_to_get_door_status: 'Harap pastikan pintu penutup tertutup untuk mengaktifkan laser rendah agar bingkai dapat berjalan.',
      fail_to_start_preview: '#803 Gagal memulai mode pratinjau. Harap mulai ulang mesin Anda atau Beam Studio. Jika kesalahan ini berlanjut, ikuti <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">panduan ini</a>.',
      headtype_mismatch: 'Modul yang tidak cocok terdeteksi. ',
      headtype_none: 'Modul tidak terdeteksi. ',
      headtype_unknown: 'Modul tidak dikenali terdeteksi. ',
      install_correct_headtype: 'Harap pasang modul laser diode 10W/20W dengan benar untuk mengaktifkan laser rendah agar bingkai dapat berjalan.',
      job_origin_unavailable: 'Pengaturan asal pekerjaan memerlukan versi firmware 4.3.5 / 5.3.5 atau yang lebih baru. Apakah Anda ingin memperbarui firmware sekarang?',
      job_origin_warning: 'Anda saat ini menggunakan "posisi saat ini" sebagai titik awal. Pastikan kepala laser dipindahkan ke posisi yang benar untuk menghindari tabrakan.',
      object_outside_moving_area: 'Beberapa objek berada di luar area pratinjau bingkai.',
      power_too_high: 'DAYA TERLALU TINGGI',
      power_too_high_confirm: 'SAYA MENGERTI',
      power_too_high_msg: 'Menggunakan daya laser yang lebih rendah (di bawah 70%) akan memperpanjang masa pakai tabung laser.\nMasukkan "SAYA MENGERTI" untuk melanjutkan.',
      pwm_unavailable: 'Mode Kedalaman memerlukan versi firmware 4.3.4 / 5.3.4 atau lebih tinggi. Apakah Anda ingin memperbarui firmware sekarang?',
      QcleanScene: 'Apakah Anda ingin menghapus gambar?<br/>Ini juga akan menghapus riwayat undo Anda!',
      start_preview_timeout: '#803 Timeout telah terjadi saat memulai mode pratinjau. Harap mulai ulang mesin Anda atau Beam Studio. Jika kesalahan ini berlanjut, ikuti <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">panduan ini</a>.',
      variable_text_warning: 'Pekerjaan ini berisi teks variabel. Sistem akan memprioritaskan pengukiran isi teks variabel dan tidak mengikuti urutan lapisan.',
    },
    frame_task: 'Pembingkaian',
    hint: {
      polygon: 'Tekan tombol + / - untuk menambah / mengurangi sisi.',
    },
    menu: {
      about: 'Tentang Beam Studio',
      about_beam_studio: 'Tentang Beam Studio',
      accessories: 'Aksesori',
      account: 'Akun',
      add_new_machine: 'Setup Mesin',
      align_center: 'Rata Tengah',
      anti_aliasing: 'Anti-Aliasing',
      auto_align: 'Penjajaran Otomatis',
      autofocus: {
        operating: 'Memfokus otomatis...',
        select_device_error: 'Silakan pilih perangkat sebelum memfokus otomatis.',
        show_probe_error: 'Tampilkan probe sebelum memfokus otomatis.',
        title: 'Fokus Otomatis',
      },
      borderless_mode: 'Mode Tanpa Batas',
      bug_report: 'Laporan Bug',
      calibrate_beambox_camera: 'Kalibrasi Kamera',
      calibrate_beambox_camera_borderless: 'Kalibrasi Kamera (Tanpa Bingkai Bawah)',
      calibrate_camera_advanced: 'Kalibrasi Kamera (Lanjutan)',
      calibrate_diode_module: 'Kalibrasi Modul Laser Diode',
      calibrate_ir_module: 'Kalibrasi Modul Inframerah',
      calibrate_printer_module: 'Kalibrasi Modul Pencetakan',
      calibrate_wide_angle_camera: 'Kalibrasi Kamera (Kamera sudut lebar)',
      calibration: 'Kalibrasi',
      camera_calibration_data: 'Data Kalibrasi Kamera',
      change_logs: 'Log Perubahan',
      clear_scene: 'File baru',
      close: 'Tutup Jendela',
      commands: 'Perintah',
      contact: 'Hubungi Kami',
      copy: 'Salin',
      cut: 'Potong',
      dashboard: 'Dasbor',
      decompose_path: 'Dekomposisi',
      delete: 'Hapus',
      design_market: 'Pasar Desain',
      dev_tool: 'Alat Debug',
      disassemble_use: 'Pisahkan',
      document_setting: 'Pengaturan Dokumen',
      document_setting_short: 'Dokumen',
      download_log: 'Unduh Log',
      download_log_canceled: 'Unduhan log dibatalkan',
      download_log_error: 'Terjadi kesalahan yang tidak diketahui, silakan coba lagi nanti',
      duplicate: 'Duplikat',
      edit: 'Sunting',
      example_files: 'Contoh Berkas',
      export_BVG: 'BVG',
      export_calibration_data: 'Ekspor Data Kalibrasi',
      export_flux_task: 'Tugas FLUX',
      export_JPG: 'JPG',
      export_PNG: 'PNG',
      export_SVG: 'SVG',
      export_to: 'Ekspor Ke...',
      export_UV_print: 'Cetak UV PDF',
      file: 'Berkas',
      fit_to_window: 'Sesuaikan Ukuran Jendela',
      follow_us: 'Ikuti kami',
      forum: 'Forum Komunitas',
      group: 'Kelompokkan',
      help: 'Bantuan',
      help_center: 'Pusat Bantuan',
      hide: 'Sembunyikan Beam Studio',
      hideothers: 'Sembunyikan Lainnya',
      image_crop: 'Potong',
      image_curve: 'Kurva',
      image_invert: 'Balik',
      image_sharpen: 'Tajamkan',
      image_stamp: 'Cap',
      image_vectorize: 'Vektorisasi',
      import_acrylic_focus_probe: 'Sonde Fokus beamo & Beambox - 3 mm',
      import_ador_laser_example: 'Contoh Laser Ador',
      import_ador_printing_example_full: 'Contoh Cetak Ador - Warna Penuh',
      import_ador_printing_example_single: 'Contoh Cetak Ador - Satu Warna',
      import_beambox_2_example: 'Contoh Beambox II',
      import_beambox_2_focus_probe: 'Sonde Fokus Beambox II - 3 mm',
      import_beamo_2_laser_example: 'Contoh Laser beamo II',
      import_beamo_2_printing_example: 'Contoh Cetak beamo II',
      import_beamo_2_printing_test: 'Uji Cetak beamo II',
      import_calibration_data: 'Impor Data Kalibrasi',
      import_hello_beambox: 'Contoh Beambox',
      import_hello_beamo: 'Contoh beamo',
      import_hexa_example: 'Contoh HEXA',
      import_hexa_rf_example: 'Contoh HEXA RF',
      import_material_printing_test: 'Uji Cetak Bahan',
      import_material_testing_cut: 'Uji Pemotongan Bahan',
      import_material_testing_engrave: 'Uji Ukiran Bahan',
      import_material_testing_line: 'Uji Garis Bahan',
      import_material_testing_old: 'Uji Pahatan Bahan - Klasik',
      import_material_testing_simple_cut: 'Uji Pemotongan Bahan - Sederhana',
      import_promark_engraving_example_1: 'Contoh Ukiran Promark I',
      import_promark_engraving_example_2: 'Contoh Ukiran Promark II',
      import_promark_example: 'Contoh Promark',
      import_promark_mopa_20w_color: 'Tes Warna MOPA 20W',
      import_promark_mopa_60w_color: 'Tes Warna MOPA 60W',
      import_promark_mopa_100w_color: 'Tes Warna MOPA 100W',
      keyboard_shortcuts: 'Pintasan keyboard',
      layer_color_config: 'Pengaturan Warna',
      layer_setting: 'Lapisan',
      link: {
        autocad: 'https://support.flux3dp.com/hc/en-us/articles/16590795274895',
        beam_studio_api: 'https://github.com/flux3dp/beam-studio/wiki/Beam-Studio-Easy-API',
        contact_us: 'https://support.flux3dp.com/hc/en-us/requests/new',
        design_market: 'https://dmkt.io',
        downloads: 'https://flux3dp.com/downloads/',
        forum: 'https://www.facebook.com/groups/flux.laser/',
        help_center: 'https://helpcenter.flux3dp.com/',
        shortcuts: 'https://support.flux3dp.com/hc/en-us/articles/10003978157455',
      },
      log: {
        camera: 'Kamera',
        cloud: 'Cloud',
        discover: 'Temukan',
        hardware: 'Perangkat Keras',
        network: 'Jaringan',
        player: 'Pemutar',
        robot: 'Robot',
        usb: 'USB',
        usblist: 'Daftar USB',
      },
      login_or_register: 'Masuk atau Daftar',
      logout: 'Keluar',
      machine_info: 'Info Mesin',
      machines: 'Mesin',
      maintenance_checklist: 'Daftar Periksa Pemeliharaan',
      manage_account: 'Kelola Akun Saya',
      material_test: 'Tes Material',
      minimize: 'Minimalkan',
      my_account: 'Akun Saya',
      network_testing: 'Tes Pengaturan Jaringan',
      object: 'Objek',
      offset: 'Ofset',
      open: 'Buka',
      paste: 'Tempel',
      paste_in_place: 'Tempel di Tempat',
      path: 'Jalur',
      photo_edit: 'Gambar',
      plugin: 'Plugin',
      preferences: 'Preferensi',
      questionnaire: 'Kuesioner Umpan Balik',
      quit: 'Keluar',
      recent: 'Buka Terbaru',
      redo: 'Ulangi',
      reload_app: 'Muat Ulang Aplikasi',
      reset: 'Atur Ulang',
      reset_layout: 'Atur Ulang Tata Letak',
      rotary_setup: 'Pengaturan Rotary',
      rotate: 'Putar',
      samples: 'Contoh',
      save_as: 'Simpan Sebagai...',
      save_scene: 'Simpan',
      save_to_cloud: 'Simpan ke Awan',
      scale: 'Skala',
      service: 'Layanan',
      set_as_default: 'Atur sebagai Default',
      show_gesture_tutorial: 'Pengenalan Gerakan Tangan',
      show_grids: 'Tampilkan Grid',
      show_layer_color: 'Gunakan Warna Lapisan',
      show_rulers: 'Tampilkan Penggaris',
      show_start_tutorial: 'Tampilkan Tutorial Mulai',
      show_ui_intro: 'Tampilkan Pengenalan Antarmuka',
      software_update: 'Pembaruan Perangkat Lunak',
      svg_edit: 'SVG',
      switch_to_beta: 'Beralih ke Rilis Beta',
      switch_to_latest: 'Beralih ke Rilis Stabil',
      tab_layers: 'Lapisan',
      tab_objects: 'Objek',
      tab_path_edit: 'Edit Jalur',
      tools: {
        title: 'Alat',
      },
      tutorial: 'Mulai Tutorial Pencetakan Delta Family',
      undo: 'Batalkan',
      ungroup: 'Lepas Kelompok',
      update: 'Periksa Pembaruan',
      update_firmware: 'Perbarui Firmware',
      update_machine: 'Perbarui mesin',
      update_mainboard: 'Perbarui motherboard',
      update_printer_board: 'Perbarui papan pengendali printer',
      using_beam_studio_api: 'Menggunakan Beam Studio API',
      view: 'Tampilan',
      window: 'Jendela',
      zoom_in: 'Perbesar',
      zoom_out: 'Perkecil',
      zoom_with_window: 'Otomatis Sesuaikan Ukuran Jendela',
    },
    rename_tab: 'Ganti nama tab',
    select_machine: 'Pilih mesin',
    tag_names: {
      dxf: 'Objek DXF',
      ellipse: 'Oval',
      fit_text: 'Kotak Teks',
      g: 'Grup',
      image: 'Gambar',
      line: 'Garis',
      multi_select: 'Beberapa Objek',
      no_selection: 'Tidak Ada Pilihan',
      pass_through_object: 'Objek Melewati',
      path: 'Jalur',
      polygon: 'Poligon',
      rect: 'Persegi Panjang',
      svg: 'Objek SVG',
      text: 'Teks',
      text_path: 'Teks pada Jalur',
      use: 'Objek Impor',
    },
    task_preview: 'Pratinjau Jalur',
    untitled: 'Tanpa Judul',
  },
  topmenu: {
    credit: 'Beam Studio dimungkinkan oleh proyek sumber terbuka <a target="_blank" href="https://github.com/flux3dp/beam-studio">Beam Studio</a> dan perangkat lunak sumber terbuka lainnya <a target="_blank" href="https://flux3dp.com/credits/">sumber terbuka</a>.',
    device: {
      download_log_canceled: 'Log unduhan dibatalkan',
      download_log_error: 'Terjadi kesalahan yang tidak diketahui, silakan coba lagi nanti',
      log: {
        usblist: 'Daftar USB',
      },
      network_test: 'Tes Jaringan',
    },
    file: {
      all_files: 'Semua File',
      clear_recent: 'Hapus Baru Dibuka',
      converting: 'Mengkonversi ke Gambar...',
      fcode_files: 'Kode FLUX',
      import: 'Impor',
      jpg_files: 'JPG',
      label: 'File',
      path_not_exit: 'Jalur ini sepertinya tidak ada lagi di disk.',
      png_files: 'PNG',
      save_fcode: 'Ekspor Tugas FLUX',
      save_jpg: 'Ekspor JPG',
      save_pdf: 'Ekspor PDF',
      save_png: 'Ekspor PNG',
      save_scene: 'Simpan Adegan',
      save_svg: 'Ekspor SVG',
      scene_files: 'Adegan Beam Studio',
      svg_files: 'SVG',
    },
    version: 'Versi',
  },
  tutorial: {
    ask_retry_calibration: 'Apakah Anda ingin mengkalibrasi kamera lagi?',
    camera_calibration_failed: 'Kalibrasi Kamera Gagal',
    gesture: {
      click: 'Ketuk untuk memilih objek.',
      drag: 'Seret untuk memilih beberapa objek.',
      hold: 'Tekan dan tahan untuk membuka menu konteks.',
      pan: 'Geser kanvas dengan dua jari.',
      zoom: 'Cubit dengan dua jari untuk memperbesar/memperkecil kanvas.',
    },
    links: {
      adjust_focus: 'https://support.flux3dp.com/hc/en-us/articles/360001684196',
    },
    look_for_machine: 'Mencari mesin untuk tutorial...',
    needNewInterfaceTutorial: 'Apakah Anda ingin memulai tutorial untuk antarmuka baru Beam Studio?<br/>(Anda dapat melewatkan ini sekarang dan memulainya nanti dengan mengklik "Bantuan" > "Tampilkan Pengantar Antarmuka".)',
    needNewUserTutorial: 'Apakah Anda ingin memulai tutorial?<br/>(Anda dapat melewatkan ini sekarang dan memulainya nanti dengan mengklik "Bantuan" > "Tampilkan Tutorial Awal".)',
    newInterface: {
      add_new_layer: 'Tambahkan Lapisan Baru',
      align_controls: 'Kontrol Perataan',
      basic_shapes: 'Bentuk Dasar',
      camera_preview: 'Pratinjau Kamera',
      drag_to_sort: 'Seret untuk mengurutkan',
      end_alert: 'Apakah Anda yakin untuk mengakhiri pengenalan UI baru?',
      flip: 'Balik',
      group_controls: 'Kontrol Pengelompokan',
      layer_controls: 'Klik kanan untuk memilih Kontrol Lapisan:\nDuplikat / Gabung / Kunci / Hapus Lapisan',
      object_actions: 'Tindakan Objek',
      pen_tool: 'Alat Pena',
      rename_by_double_click: 'Ganti nama dengan klik dua kali',
      select_image_text: 'Pilih / Gambar / Teks',
      select_machine: 'Pilih mesin',
      shape_operation: 'Operasi Bentuk',
      start_work: 'Mulai Bekerja',
      switch_between_layer_panel_and_object_panel: 'Beralih antara Panel Lapisan dan Panel Objek',
    },
    newUser: {
      add_new_layer: 'Tambahkan Lapisan Baru',
      adjust_focus: '2. Sesuaikan fokus',
      close_cover: '3. Tutup penutup',
      drag_to_draw: 'Seret untuk Menggambar',
      draw_a_circle: 'Gambar Lingkaran',
      draw_a_rect: 'Gambar Persegi Panjang',
      end_alert: 'Apakah Anda yakin untuk mengakhiri tutorial?',
      end_preview_mode: 'Akhiri Mode Pratinjau',
      infill: 'Nyalakan Isi',
      please_select_wood_cutting: 'Silakan pilih preset "Kayu - Potong"',
      please_select_wood_engraving: 'Mohon pilih Preset "Kayu - Pengukiran".',
      preview_the_platform: 'Pratinjau Platform',
      put_wood: '1. Letakkan contoh kayu',
      send_the_file: 'Kirim Berkas',
      set_preset_wood_cut: 'Atur Preset: Kayu - Potong',
      set_preset_wood_engraving: 'Atur Preset: Kayu - Pengukiran',
      start_tutorial: 'Tutorial Mulai',
      switch_to_layer_panel: 'Beralih ke Panel Lapisan',
      switch_to_object_panel: 'Beralih ke Panel Objek',
      switch_to_preview_mode: 'Beralih ke Mode Pratinjau',
    },
    next: 'BERIKUTNYA',
    retry: 'Coba lagi',
    set_connection: 'Atur Koneksi',
    skip: 'Lewati',
    skip_tutorial: 'Anda telah melewati tutorial. Anda selalu dapat memulai tutorial dengan mengklik "Bantuan" > "Tampilkan Tutorial Awal"',
    suggest_calibrate_camera_first: 'Kami menyarankan pengguna untuk mengkalibrasi kamera pada awalnya dan mengatur ulang fokus sebelum setiap pratinjau untuk hasil yang optimal.<br/>Apakah Anda ingin mengonfirmasi untuk melakukan kalibrasi sekarang?<br/>(Anda dapat melewatkan ini sekarang dan melakukannya nanti dengan mengklik "Menu" > "Mesin" > [Mesin Anda] > "Kalibrasi Kamera".)',
    tutorial_complete: 'Itu semua untuk tutorialnya. Sekarang saatnya untuk membuat!',
    unable_to_find_machine: 'Tidak dapat menemukan mesin untuk Tutorial. Apakah Anda ingin pergi ke halaman pengaturan koneksi, mencoba lagi atau melewati tutorial?',
    welcome: 'SELAMAT DATANG',
  },
  update: {
    cannot_reach_internet: '#823 Server tidak dapat dijangkau<br/>Harap periksa koneksi internet',
    download: 'PEMBARUAN ONLINE',
    firmware: {
      caption: 'Pembaruan Firmware untuk mesin tersedia',
      confirm: 'UNGGAH',
      firmware_too_old_update_by_sdcard: 'Versi firmware terlalu lama. Harap perbarui firmware menggunakan kartu SD.',
      force_update_message: '#814 Harap perbarui mesin Anda ke versi firmware terbaru.',
      latest_firmware: {
        cant_get_latest: 'Tidak dapat mendapatkan informasi firmware terbaru.',
        caption: 'Pembaruan Firmware Mesin',
        message: 'Anda memiliki Firmware Mesin terbaru',
        still_update: 'PERBARUI',
      },
      message_pattern_1: '"%s" siap untuk pembaruan firmware.',
      message_pattern_2: '%s Firmware v%s sekarang tersedia - Anda memiliki v%s.',
      too_old_for_web: 'Versi firmware mesin Anda saat ini adalah v%s.\nJika Anda ingin menggunakan versi online dari Beam Studio, harap perbarui firmware mesin ke versi terbaru.',
      update_fail: '#822 Pembaruan Gagal',
      update_success: 'Pembaruan firmware berhasil diunggah',
      upload_firmware_title: 'Firmware upload (*.fxfw)',
      upload_mainboard_title: 'Unggah firmware motherboard (*.bin)',
      upload_printer_board_title: 'Unggah firmware papan printer (*.bin)',
    },
    install: 'PASANG',
    later: 'NANTI',
    preparing: 'Mempersiapkan...',
    release_note: 'Catatan Rilis:',
    skip: 'Lewati Versi Ini',
    software: {
      available_switch: 'Beam Studio v%s tersedia sekarang. Anda memiliki v%s. Apakah Anda ingin beralih ke versi ini?',
      available_update: 'Beam Studio v%s tersedia sekarang. Anda memiliki v%s. Apakah Anda ingin mengunduh pembaruan?',
      caption: 'Pembaruan Perangkat Lunak Beam Studio tersedia',
      check_update: 'Periksa Pembaruan',
      checking: 'Memeriksa Pembaruan',
      downloading: 'Mengunduh pembaruan di latar belakang, Anda dapat mengeklik "OK" untuk melanjutkan pekerjaan Anda.',
      install_or_not: '%s siap untuk diperbarui. Apakah Anda ingin memulai ulang dan memperbarui sekarang?',
      no: 'Tidak',
      no_response: 'Gagal terhubung ke server, harap periksa pengaturan jaringan Anda.',
      not_found: 'Anda menggunakan versi Beam Studio terbaru.',
      switch_or_not: '%s siap untuk beralih. Apakah Anda ingin memulai ulang dan beralih sekarang?',
      switch_version: 'Ganti Versi',
      switch_version_not_found: 'Versi yang dapat diubah tidak ditemukan.',
      update_for_ador: 'Versi perangkat lunak saat ini %s tidak kompatibel, harap unduh versi terbaru dari Beam Studio untuk Ador.',
      yes: 'Ya',
    },
    update: 'Perbarui',
    updating: 'Memperbarui...',
    upload: 'UNGGAH',
  },
  variable_text_settings: {
    advance_by: 'Maju sebanyak',
    auto_advance: 'Lanjut otomatis',
    auto_advance_hint: 'Secara otomatis beralih ke data variabel berikutnya setiap kali pekerjaan dijalankan.',
    bake: 'Selesaikan',
    bake_description: 'Hapus variabilitas dan ubah ke teks biasa',
    browse: 'Jelajahi',
    clear: 'Bersihkan',
    csv_file: 'File CSV',
    current: 'Saat ini',
    end: 'Akhir',
    failed_to_convert: 'Objek teks variabel berisi format yang tidak didukung, yang dapat menyebabkan konten tidak ditampilkan.',
    file_error: 'Gagal mengurai file CSV, harap periksa format file.',
    file_size_exceeded: 'Unggah file gagal, ukuran file melebihi 5 MB.',
    next: 'Berikutnya',
    note: 'Pengaturan ini akan secara otomatis diterapkan pada semua teks variabel',
    previous: 'Sebelumnya',
    start: 'Mulai',
    test: 'Tes',
    test_description: 'Tekan dan tahan untuk melihat teks variabel',
    title: 'Pengaturan teks variabel',
  },
  web_cam: {
    image_to_small: 'Ukuran gambar kamera terlalu kecil. Gambar mungkin rusak.',
    no_device: 'Tidak dapat mendeteksi perangkat kamera. Silakan sambungkan kembali kamera dan coba lagi.',
    no_permission: 'Beam Studio tidak memiliki izin untuk mengakses kamera. Pastikan izin diberikan ke Beam Studio di pengaturan browser atau pengaturan sistem.',
  },
  welcome_page: {
    follow_us: {
      subtitle: 'Dapatkan inspirasi, promo, hadiah gratis dan terhubung dengan pengguna FLUX!',
      user_group: 'Grup Pengguna',
    },
    help_center: {
      guides: 'Panduan',
      guides_subtitle: 'Lihat panduan lengkap untuk semua produk FLUX.',
      submit_request: 'Ajukan Permintaan',
      subtitle: 'Panduan, manual, dan sumber dukungan untuk semua hal tentang FLUX.',
      visit_help_center: 'Kunjungi Pusat Bantuan',
    },
    member_center: 'Pusat Anggota',
    member_center_url: 'https://member.flux3dp.com/en-US/machine-register',
    new_project: 'Proyek Baru',
    not_login_placeholder: 'Dapatkan kredit AI gratis dari kami saat Anda mendaftar akun FLUX!',
    recent_files: 'File terbaru',
    shop: 'Toko',
    shop_products: 'Beli produk FLUX',
  },
  z_speed_limit_test: {
    alert_before: 'Sebelum memulai ukiran kurva, sistem akan melakukan uji beban untuk mencegah kehilangan langkah akibat berat yang berlebihan.',
    alert_failed: 'Berat objek saat ini melebihi batas beban untuk kecepatan sumbu Z saat ini. Kurangi kecepatan sumbu Z pada panel mesin atau ganti objek ukiran sebelum melakukan pengujian ulang.',
    ignore: 'Abaikan',
    retest: 'Uji ulang',
    testing: 'Melakukan uji beban...',
  },
};

export default lang;
